export const rawItems = {
  "1": {
    name: "An acrylic ball",
    verb: ["play with"],
    moods: ["playful", "curious"],
    location: ["indoors", "outdoors"],
    preparationType: "Get",
    tags: ["material", "illusion"],
    ingredients: ["Acrylic ball"],
    optionalIngredients: [],
    withWhom: ["myself"],
    description:
      "Acrylic balls are cool. Try rolling it around between your hands. Roll it across the room. Watch the world through it.",
    link: [],
    id: "1",
  },
  "2": {
    name: "A reflective ball",
    verb: ["play with"],
    moods: ["playful", "curious"],
    location: ["indoors", "outdoors"],
    preparationType: "Get",
    tags: ["material", "illusion"],
    ingredients: ["Reflective ball"],
    optionalIngredients: [],
    withWhom: ["friends", "myself"],
    "purchase link": "https://amzn.to/3zn2T3T",
    link: [],
    id: "2",
  },
  "3": {
    name: "Lights",
    verb: ["look at"],
    moods: ["playful", "curious", "cozy", "passive", "visual", "creative"],
    location: ["indoors", "outdoors"],
    tags: ["colors", "light", "material", "category"],
    ingredients: [
      "Cube lights",
      "EL wire",
      "Fiber optic lights",
      "Candles",
      "Colorful lights",
    ],
    optionalIngredients: [],
    withWhom: ["friends", "myself"],
    description:
      "Play with the position of the lights. Place them close and far away from each other. Watch how this affects shadows of the objects around you. Move the lights around your face and watch shadows move with it. Dim or turn up the brightness. Squint.",
    link: [],
    id: "3",
  },
  "6": {
    name: "EL wire",
    verb: ["play with"],
    moods: ["creative", "colorful", "visual", "playful"],
    location: ["indoors", "outdoors"],
    preparationType: "Get",
    tags: ["light", "colors", "material"],
    ingredients: ["EL wire"],
    optionalIngredients: [],
    withWhom: ["friends", "myself"],
    description:
      "Thread the EL wire through a cardboard to create a sign or a shape. Wrap EL wire around your arm and turn off the lights in the room. Make an EL wire crown. Draw a labyrinth on the floor using EL wire. What happens next?",
    link: [],
    id: "6",
  },
  "7": {
    name: "Mirror cube",
    verb: ["play with"],
    moods: ["playful", "curious"],
    location: ["indoors", "outdoors"],
    preparationType: "Get",
    tags: ["illusion", "material"],
    ingredients: ["Mirror cube"],
    optionalIngredients: ["Colorful lights"],
    withWhom: ["friends", "myself"],
    description:
      "Stack multiple cubes on top of one another. Put lights around the cube and watch how the reflections change. Place a prize in or on the cube, give it to yourself if you have a eureka moment.",
    "purchase link": "https://amzn.to/3iDZeZl",
    link: [],
    id: "7",
  },
  "8": {
    name: "Fabric",
    verb: ["touch"],
    moods: ["cozy", "tactile", "passive", "creative"],
    location: ["indoors", "outdoors"],
    tags: ["material", "colors", "texture", "category"],
    ingredients: ["Linen", "Corduroy", "Velvet", "Wool", "Microfiber"],
    optionalIngredients: [],
    withWhom: ["friends", "myself"],
    preparation:
      "Gather different kinds of fabric around. These could be from clothes, blankets, towels, or scrap pieces of fabric. Lay them all out on the floor.",
    description:
      "Touch the pieces of fabric with your fingertips. Touch them with your forearms. Touch them on your cheeks. Pay attention to how different the textures feel. Are they soft? Do they have ridges? Do they feel good to touch?",
    link: [],
    id: "8",
    type: "Material,Activity",
  },
  "9": {
    name: "Blankets",
    verb: ["cozy up in"],
    moods: ["cozy", "warm"],
    location: ["indoors", "outdoors"],
    tags: ["material", "texture", "cozy", "warm", "comfort"],
    ingredients: ["Blankets"],
    optionalIngredients: [],
    withWhom: ["friends", "myself"],
    link: [],
    id: "9",
  },
  "10": {
    name: "Clothing",
    verb: ["take off"],
    moods: ["playful", "curious", "active"],
    location: ["indoors", "outdoors"],
    tags: ["material", "texture", "comfort"],
    ingredients: ["Clothes"],
    optionalIngredients: [],
    withWhom: ["friends", "myself"],
    description:
      "It's time to take off your clothes. Carefully remove one item of clothing. If you feel lighter, remove more until you feel completely free.",
    link: [],
    id: "10",
  },
  "11": {
    name: "Food",
    verb: ["eat"],
    moods: ["hungry", "curious"],
    location: ["indoors", "outdoors"],
    tags: ["material", "colors", "food", "category"],
    ingredients: ["Food", "Fruits"],
    optionalIngredients: [],
    withWhom: ["friends", "myself"],
    preparation:
      "Make sure the fridge is stocked in case you get hungry. We recommend fruits, soylent, cereal, berries and cream. If anything needs chopping, make sure to chop it up and have it ready to take out and eat without additional effort.",
    description:
      "Enjoy your food! Eat slowly. Pay attention to the sensations in your mouth. What are the individual tastes and textures? Eat with your fingers.",
    link: [],
    id: "11",
  },
  "14": {
    name: "Scents",
    verb: ["smell"],
    moods: ["cozy", "passive", "calm"],
    location: ["indoors"],
    preparationType: "Get",
    tags: ["material", "category", "scent"],
    ingredients: [
      "Incense",
      "Essential oils",
      "Candles",
      "Soaps",
      "Palo santo",
    ],
    optionalIngredients: ["Essential oil diffuser"],
    withWhom: ["myself"],
    preparation:
      "Gather interesting scents and lay them out to use during your experience.",
    description:
      "Fill the room with a scent that matches your mood. Gift yourself a scent to lift your mood.",
    link: [],
    id: "14",
  },
  "18": {
    name: "Wire",
    verb: ["use"],
    moods: ["creative"],
    location: ["indoors", "outdoors"],
    preparationType: "Get",
    tags: ["material", "art", "tool"],
    ingredients: ["Wire"],
    optionalIngredients: [],
    withWhom: ["myself"],
    description:
      "Pick a shape. It could be abstract. It could be something that reminds you of a distinct memory. Build that shape by bending the wire and making a sculpture.",
    link: [],
    id: "18",
    type: "Material,Activity",
  },
  "20": {
    name: "An essential oil diffuser",
    verb: ["use"],
    moods: ["calm", "passive", "creative"],
    location: ["indoors"],
    preparationType: "Get",
    tags: ["scent", "material"],
    ingredients: ["Essential oils", "Essential oil diffuser"],
    optionalIngredients: ["Colorful lights", "Lasers"],
    withWhom: ["friends", "myself"],
    description:
      "Watch the steam rise out of the essential oil diffuser. Play with shining lights or lasers through the steam.",
    link: [],
    id: "20",
  },
  "21": {
    name: "Beautiful books",
    verb: ["look at"],
    moods: ["curious", "visual", "cozy"],
    location: ["indoors"],
    tags: ["material", "visual", "discovery", "category"],
    ingredients: ["Books"],
    optionalIngredients: [],
    withWhom: ["myself"],
    preparation: "Stack a list of beautiful, immersive books.",
    description:
      "Look at the art in the books. Try to notice as many details as you can on each page. Consider why you like the art.",
    link: [],
    id: "21",
  },
  "22": {
    name: "Arts & crafts",
    verb: ["make"],
    moods: ["creative", "active", "playful", "artsy"],
    location: ["indoors"],
    tags: ["art", "category", "visual"],
    ingredients: [
      "Paper",
      "Colorful pencils",
      "Markers",
      "Watercolor",
      "Acrylics",
      "Ink",
      "Sketchpads",
      "Paper",
    ],
    optionalIngredients: [],
    withWhom: ["friends", "myself"],
    preparation:
      "Lay out your arts and crafts materials in a place where you can easily access them.",
    description:
      "Create as your heart pleases. Draw! Paint! Express how you feel. Express how you felt yesterday. Express your dreams. Express your childhood. Play with the colors, pick a shape and abstract it out to its raw elements. Color outside the lines. Browse through magazines, cut out shapes and create collages. Unlimit yourself.",
    link: [],
    id: "22",
    select: "Needs work",
  },
  "23": {
    name: "A kite",
    verb: ["fly", "play with"],
    moods: ["active"],
    location: ["outdoors"],
    preparationType: "Get",
    tags: ["outside", "motion", "activity", "sky", "material"],
    ingredients: ["Kite"],
    optionalIngredients: [],
    withWhom: ["friends", "myself"],
    link: [],
    id: "23",
  },
  "24": {
    name: "A hammock",
    verb: ["lie on"],
    moods: ["cozy", "passive", "tired", "serene", "calm"],
    location: ["outdoors"],
    preparationType: "Get",
    tags: ["comfort", "outside", "material"],
    ingredients: ["Hammock"],
    optionalIngredients: [],
    withWhom: ["friends", "myself"],
    link: [],
    id: "24",
  },
  "25": {
    name: "Rope",
    verb: ["use"],
    moods: ["creative", "active"],
    location: ["indoors", "outdoors"],
    preparationType: "Get",
    tags: ["material", "build", "hang", "tool"],
    ingredients: [],
    optionalIngredients: [],
    withWhom: ["myself"],
    description: "Create a spiral labyrinth on the floor.\n",
    link: [],
    id: "25",
    type: "Material",
  },
  "26": {
    name: "Tinted glasses",
    verb: ["play with", "look through"],
    moods: ["visual", "creative", "playful", "curious"],
    location: ["indoors"],
    preparationType: "Get",
    tags: ["material", "colors"],
    ingredients: ["Tinted glasses"],
    optionalIngredients: [],
    withWhom: ["friends", "myself"],
    description: "Look at the world through a different color.",
    "purchase link": "https://amzn.to/3gpoLD0",
    link: [],
    id: "26",
  },
  "27": {
    name: "Lying down glasses",
    verb: ["play with"],
    moods: ["tired", "playful", "curious"],
    location: ["indoors", "outdoors"],
    preparationType: "Get",
    tags: ["material", "illusion", "comfort"],
    ingredients: [],
    optionalIngredients: [],
    withWhom: ["friends", "myself"],
    "purchase link": "https://amzn.to/2SmDS8t",
    link: [
      "https://www.amazon.com/Valuu-Spectacles-Horizontal-Definition-Eyeglasses/dp/B07FCRXX5H/ref=sr_1_6?dchild=1&keywords=lazy+reading+glasses&qid=1618123872&sr=8-6",
    ],
    id: "27",
  },
  "29": {
    name: "Textures",
    verb: ["touch"],
    moods: ["cozy", "tactile", "creative", "curious", "playful"],
    location: ["indoors", "outdoors"],
    tags: ["texture", "category", "material"],
    ingredients: [],
    optionalIngredients: [
      "Linen",
      "Corduroy",
      "Microfiber",
      "Velvet",
      "Pets",
      "Skin",
      "Avocado",
      "Dragon fruit",
      "Metal",
      "Ice cubes",
    ],
    withWhom: ["friends", "myself"],
    description: "Touch everything.",
    link: [],
    id: "29",
  },
  "30": {
    name: "Calligraphy",
    verb: ["make"],
    moods: ["creative", "active", "playful", "artsy"],
    location: ["indoors"],
    tags: ["visual", "art", "category"],
    ingredients: [],
    optionalIngredients: [
      "Markers",
      "Fountain pens",
      "Highlighters",
      "Ink",
      "Colorful pens",
    ],
    withWhom: ["friends", "myself"],
    description: "Pick a word or a phrase. Create your own calligraphy.",
    link: [],
    id: "30",
    type: "Material",
  },
  "31": {
    name: "A fountain pen",
    verb: ["play with", "use"],
    moods: ["creative", "pensive"],
    location: ["indoors"],
    preparationType: "Get",
    tags: ["visual", "art", "tool", "material"],
    ingredients: [],
    optionalIngredients: [],
    withWhom: ["friends", "myself"],
    description:
      "Write a letter. Try writing on different kinds of paper and watch how to ink spreads.",
    link: [],
    id: "31",
    type: "Material",
  },
  "32": {
    name: "Marbled/pressed paper",
    verb: ["use"],
    moods: ["creative", "pensive"],
    location: ["indoors"],
    preparationType: "Get",
    tags: ["art", "tool", "colors", "material"],
    ingredients: ["Marbled paper"],
    optionalIngredients: ["Glue", "Painters tape", "Scissors"],
    withWhom: ["friends", "myself"],
    description:
      "Write or draw on marbled paper. Trace the patterns. Cut out pieces and glue them on another object. Tape over your walls.\n",
    link: [],
    id: "32",
    type: "Material",
  },
  "33": {
    name: "Awesome wrapping paper",
    verb: ["use"],
    moods: ["creative", "visual"],
    location: ["indoors"],
    preparationType: "Get",
    tags: ["art", "tool", "visual", "material"],
    ingredients: ["Wrapping paper"],
    optionalIngredients: [],
    withWhom: ["friends", "myself"],
    description: "Cover the floors, your walls, and your furniture.",
    link: [],
    id: "33",
    type: "Material",
  },
  "34": {
    name: "Marbles",
    verb: ["play with"],
    moods: ["creative", "playful", "curious", "visual"],
    location: ["indoors"],
    preparationType: "Get",
    tags: ["material", "game", "texture", "colors"],
    ingredients: ["Marbles"],
    optionalIngredients: [],
    withWhom: ["friends", "myself"],
    description:
      "Roll around marbles in your hand as a way to fidget. Try marble racing. Shine lights through the marbles.",
    "purchase link": "https://amzn.to/3xhyXnP",
    link: [],
    id: "34",
    type: "Material,Activity",
  },
  "37": {
    name: "Tokaji wine",
    verb: ["drink"],
    moods: ["hungry", "thirsty", "mellow"],
    location: ["indoors"],
    preparationType: "Get",
    tags: ["alcohol", "drink"],
    ingredients: ["Tokaji"],
    optionalIngredients: [],
    withWhom: ["friends", "myself"],
    description:
      "Tokaji dessert wine is delicious. Keep it chilled and pour yourself a small amount when you want to celebrate a euphoric moment.",
    link: ["https://en.wikipedia.org/wiki/Tokaji"],
    id: "37",
  },
  "39": {
    name: "A voice modulator",
    verb: ["play with"],
    moods: ["playful", "auditory", "curious"],
    location: ["indoors"],
    preparationType: "Get",
    tags: ["sound", "music", "material", "illusion"],
    ingredients: ["A voice modulator"],
    optionalIngredients: [],
    withWhom: ["friends"],
    "purchase link": "https://amzn.to/3vl0eEq",
    link: [],
    id: "39",
  },
  "40": {
    name: "Music",
    verb: ["listen to"],
    moods: ["cozy", "active", "passive", "tired", "curious", "pensive"],
    location: ["indoors", "outdoors"],
    tags: ["category", "music"],
    ingredients: ["Playlists"],
    optionalIngredients: ["Bluetooth speaker"],
    withWhom: ["friends", "myself"],
    preparation:
      "Collect playlists you enjoy. Pick some playlists based on your mood. Browse our recommended playlists.",
    description:
      "Put on an immersive playlist. Lie down. Turn up the volume (but be considerate of any neighbors!)",
    link: [],
    id: "40",
  },
  "41": {
    name: "A movie",
    verb: ["watch"],
    moods: ["visual", "tired"],
    location: ["indoors"],
    tags: ["passive", "visual", "activity", "decoration", "screens"],
    ingredients: [],
    optionalIngredients: ["Projector"],
    withWhom: ["friends", "myself"],
    preparation:
      "Pick an immersive. Make sure you have it downloaded or on streaming",
    link: [],
    id: "41",
    select: "Needs work",
  },
  "44": {
    name: "McSweeney’s",
    verb: ["browse"],
    moods: ["curious", "cozy"],
    location: ["indoors"],
    preparationType: "Get",
    tags: ["discovery", "material"],
    ingredients: [],
    optionalIngredients: ["McSweeny's"],
    withWhom: ["friends", "myself"],
    link: [],
    id: "44",
  },
  "45": {
    name: "Oobleck",
    verb: ["play with"],
    moods: ["active", "experimental"],
    location: ["outdoors", "indoors"],
    preparationType: "Get",
    tags: ["material", "activity", "messy", "illusion"],
    ingredients: ["Corn starch", "Water", "Bucket"],
    optionalIngredients: ["Food coloring"],
    withWhom: ["friends"],
    preparation:
      "You might want to lay down a towel or newspapers under your bucket if you are doing this indoors.",
    description:
      "Mix 1 part water with 1.5 to 2 parts cornstarch. You may wish to start with one cup of water and one and a half cups of cornstarch, then work in more cornstarch if you want a more 'solid' oobleck. It will take about 10 minutes of mixing to get a nice homogeneous oobleck.\nMix in a few drops of food coloring if you want colored oobleck. Slowly lower your hand into oobleck then try to quickly pull it out. Try squeezing some of the oobleck or punching it.",
    link: [],
    id: "45",
  },
  "46": {
    name: "Body paint",
    verb: ["use"],
    moods: [
      "romantic",
      "creative",
      "sensual",
      "visual",
      "tactile",
      "sensory",
      "colorful",
      "playful",
    ],
    location: ["indoors", "outdoors"],
    preparationType: "Get",
    tags: ["visual", "sensual", "colors", "activity", "romance"],
    ingredients: ["Body paint"],
    optionalIngredients: [],
    withWhom: ["friends", "my partner"],
    description:
      "Paint on each other. Try to create a story. Paint with your eyes closed. Paint but don't let the other person see what you're painting until you're done. Feel free to use your entire body.",
    link: [],
    id: "46",
  },
  "48": {
    name: "A kiddie pool",
    verb: ["play in"],
    moods: ["playful", "cooling", "watery"],
    location: ["outdoors"],
    preparationType: "Get",
    tags: [
      "water",
      "outside",
      "messy",
      "activity",
      "refreshing",
      "sunny",
      "colors",
      "material",
    ],
    ingredients: ["Kiddie pool", "Waterproof paint"],
    optionalIngredients: [],
    withWhom: ["friends"],
    preparation: "Inflate the kiddy pool but don't fill it with water yet.",
    description:
      "Paint swirls or patterns on the bottom of the kiddie pool with waterproof paint. When it's dry, fill the pool with water and get inside.",
    link: [],
    id: "48",
  },
  "49": {
    name: "Marbling art",
    verb: ["make"],
    moods: ["creative", "visual", "active"],
    location: ["indoors"],
    preparationType: "Get",
    tags: ["messy", "art", "visual", "activity"],
    ingredients: ["Marbling kit", "Paper", "Water"],
    optionalIngredients: [],
    withWhom: ["friends", "myself"],
    "purchase link": "https://amzn.to/3gsGY2w",
    link: [],
    id: "49",
  },
  "50": {
    name: "Pure black",
    verb: ["paint things"],
    moods: ["creative", "visual"],
    location: ["indoors"],
    preparationType: "Get",
    tags: ["material", "illusion"],
    ingredients: ["Pure black paint"],
    optionalIngredients: [],
    withWhom: ["friends", "myself"],
    preparation:
      "Find something you want to turn into pure black. This can be a toy or just a piece of paper.",
    description:
      "Paint your object pure black. This black paint will not reflect back any light and turn your object into a ghostly shape.",
    "purchase link": "https://amzn.to/3zpMueQ",
    link: [],
    id: "50",
  },
  "51": {
    name: "A fidget spinner",
    verb: ["play with"],
    moods: ["focused", "playful", "visual"],
    location: ["indoors"],
    preparationType: "Get",
    tags: ["material", "play"],
    ingredients: ["Fidget spinner"],
    optionalIngredients: [],
    withWhom: ["friends", "myself"],
    description:
      "Simply fidget! There is a task that needs to be done? Whoever spins the spinner for the shortest amount of time is the one that has to do it.",
    "purchase link": "https://amzn.to/3xify6l",
    link: [],
    note: "Maybe this is a mechanism by which to decide something\n",
    id: "51",
    type: "Material",
  },
  "52": {
    name: "Kinetic sand",
    verb: ["play with"],
    moods: ["tactile", "playful"],
    location: ["indoors"],
    preparationType: "Get",
    tags: ["texture", "material", "colors", "play"],
    ingredients: ["Kinetic sand"],
    optionalIngredients: [],
    withWhom: ["friends", "myself"],
    preparation: "Prepare a container or a surface for your sand art.",
    description: "Build a map of your dream universe.",
    "purchase link": "https://amzn.to/3wlTJTp",
    link: [],
    id: "52",
    select: "Needs work",
  },
  "53": {
    name: "A kaleidoscope",
    verb: ["look at", "play with"],
    moods: ["visual"],
    location: ["indoors"],
    preparationType: "Get",
    tags: ["colors", "light", "material"],
    ingredients: ["Kaleidoscope"],
    optionalIngredients: [],
    withWhom: ["myself", "friends"],
    description:
      "Try shining a flashlight through the end of the kaleidoscope.",
    "purchase link": "https://amzn.to/3guR4zZ",
    link: [],
    id: "53",
    type: "Material",
  },
  "54": {
    name: "A teleidoscope",
    verb: ["play with", "look at"],
    moods: ["visual"],
    location: ["indoors", "outdoors"],
    preparationType: "Get",
    tags: ["material", "illusion"],
    ingredients: ["Teleidoscope"],
    optionalIngredients: [],
    withWhom: ["myself", "friends"],
    link: [],
    id: "54",
    type: "Material",
  },
  "55": {
    name: "A white crayon",
    verb: ["play with"],
    moods: ["creative", "playful", "private"],
    location: ["indoors"],
    preparationType: "Get",
    tags: ["material", "art", "visual", "activity"],
    ingredients: ["A white crayon", "Ink"],
    optionalIngredients: [],
    withWhom: ["myself"],
    description:
      "Draw patterns on the piece of paper using the white crayon. Paint with ink over it.",
    link: [],
    id: "55",
  },
  "56": {
    name: "Rain works",
    verb: ["play with"],
    moods: ["creative", "playful"],
    location: ["outdoors"],
    preparationType: "Get",
    tags: ["discovery", "illusion", "art", "activity"],
    ingredients: ["Rain works"],
    optionalIngredients: [],
    withWhom: ["friends"],
    description:
      "Paint a shape over the sidewalk using rain works spray. Have your friends guess the shape. Pour water over the shape to reveal your drawing.",
    "purchase link": "https://amzn.to/3cAZyV0",
    link: ["http://imgur.com/gallery/pHTfvmW", " https://rain.works/"],
    id: "56",
  },
  "57": {
    name: "Infinity mirrors",
    verb: ["look at"],
    moods: ["visual", "philosophical", "creative"],
    location: ["indoors"],
    preparationType: "Prepare materials for",
    tags: ["illusion", "material", "immersive"],
    ingredients: ["Mirrors"],
    optionalIngredients: ["Fiber optic lights"],
    withWhom: ["friends", "myself"],
    preparation:
      "Place the four mirrors around you such that they make a rectangle. Secure the mirrors so they will not fall.",
    description:
      "Watch the infinity of events that unfold. Experiment playing around with lights.",
    link: [],
    note: "May need to rework to be built with mirror sheets or something",
    id: "57",
    select: "Needs work",
    type: "Material",
  },
  "59": {
    name: "K’nex",
    verb: ["play with"],
    moods: ["playful", "creative"],
    location: ["indoors"],
    preparationType: "Get",
    tags: ["material", "build", "activity", "outside"],
    ingredients: ["K'nex"],
    optionalIngredients: [],
    withWhom: ["friends", "myself"],
    "purchase link": "https://amzn.to/3cCrjwG",
    link: [],
    id: "59",
  },
  "60": {
    name: "Lasers",
    verb: ["play with"],
    moods: ["playful", "creative", "curious", "visual"],
    location: ["indoors"],
    preparationType: "Get",
    tags: ["light", "illusion", "material"],
    ingredients: ["Lasers"],
    optionalIngredients: ["Incense", "Essential oil diffuser", "Candles"],
    withWhom: ["friends", "myself"],
    description:
      "Shine lasers in the dark. Shine lasers to lead the way. Shine lasers through smoke or steam.",
    "purchase link": "https://amzn.to/3czDI47",
    link: [],
    id: "60",
  },
  "62": {
    name: "Origami cubes",
    verb: ["make"],
    moods: ["playful", "creative", "artsy", "visual"],
    location: ["indoors"],
    tags: ["activity", "visual", "material"],
    ingredients: ["Paper", "Ruler"],
    optionalIngredients: ["Marbled paper", "Wrapping paper"],
    withWhom: ["friends"],
    preparation:
      "Print [this tutorial](https://www.onecrazymom.com/how-to-make-an-origami-cube/) in advance if you want an experience without screens",
    description:
      "Make origami cubes. Try to match as many patterns as possible. You can stack them up to build a structure or hide little objects in them to open them up later.",
    link: [],
    id: "62",
    select: "Needs work",
  },
  "63": {
    name: "Geometric shapes",
    verb: ["play with"],
    moods: ["playful", "curious", "creative"],
    location: ["indoors"],
    tags: ["material", "category"],
    ingredients: ["Paper", "Ruler"],
    optionalIngredients: ["Glue", "Marbled paper", "Wrapping paper"],
    withWhom: ["friends", "myself"],
    preparation:
      "Print [this list of shapes](https://byjus.com/maths/geometric-shapes/) in advance if you want an experience without screens.",
    description:
      "Cut out many different geometric shapes. Do the squares look square? Overlap the shapes to observe the kinds of interactions they make. Try to find how often each shape occurs in your environment. Do a creative exercise of what it must feel like to be that shape.",
    link: [],
    id: "63",
  },
  "64": {
    name: "Topographical shapes on the wall or the floor",
    verb: ["make", "create"],
    moods: ["creative", "active"],
    location: ["indoors"],
    tags: ["activity"],
    ingredients: ["Painters tape"],
    optionalIngredients: [],
    withWhom: ["friends", "myself"],
    description:
      "Imagine a topographical map. Create concentric shapes on the floor or the wall with tape to create a new topography.",
    link: [],
    id: "64",
  },
  "65": {
    name: "Kinetic foam",
    verb: ["play with"],
    moods: ["tactile", "playful"],
    location: ["indoors"],
    preparationType: "Get",
    tags: ["material", "texture", "colors"],
    ingredients: [],
    optionalIngredients: [],
    withWhom: ["friends", "myself"],
    preparation: "Prepare a container or a surface for your sand art.",
    description:
      "Play. Build two sculptures. One that represents your inner demon and one that represents your inner angel.",
    link: [],
    id: "65",
  },
  "66": {
    name: "Reflective strips",
    verb: ["drape"],
    moods: ["creative", "alien"],
    location: ["indoors"],
    preparationType: "Get",
    tags: ["illusion", "immersive", "material"],
    ingredients: ["Painters tape", "Thermal sheets"],
    optionalIngredients: ["Scissors", "Tin foil"],
    withWhom: ["friends", "myself"],
    preparation:
      "Tear long, thin strips of the foil and tape them to hang from the ceiling. Use lots of strips to create an alien environment.",
    "purchase link": "https://amzn.to/2TrQsU0",
    link: [],
    id: "66",
    type: "Environment",
  },
  "67": {
    name: "Giant balloons",
    verb: ["play with", "use"],
    moods: ["visual", "immersive", "playful"],
    location: ["indoors", "outdoors"],
    preparationType: "Get",
    tags: ["material", "colors", "light", "immersive"],
    ingredients: ["Giant balloons"],
    optionalIngredients: ["Balloon pump"],
    withWhom: ["friends", "myself"],
    preparation: "Fill the room with giant balloons",
    "purchase link": "https://amzn.to/3veOrYx",
    link: [],
    note: "Balloon pump link: https://amzn.to/3ghBJ6P",
    id: "67",
    type: "Environment",
  },
  "70": {
    name: "Bubbles",
    verb: ["play with"],
    moods: ["curious", "playful", "visual"],
    location: ["outdoors", "indoors"],
    preparationType: "Get",
    tags: ["illusion", "activity", "material"],
    ingredients: ["Bubbles"],
    optionalIngredients: ["Bubble maker"],
    withWhom: ["friends", "myself"],
    "purchase link": "https://amzn.to/3xhQnkb",
    link: [],
    note: "Could also link to giant bubbles",
    id: "70",
    type: "Environment,Activity",
  },
  "71": {
    name: "A decorated hula hoop",
    verb: ["play with"],
    moods: ["active", "playful"],
    location: ["outdoors"],
    preparationType: "Prepare materials for",
    tags: ["material", "activity", "illusion", "motion", "movement"],
    ingredients: ["Hula hoop", "Ribbons"],
    optionalIngredients: [],
    withWhom: ["friends", "myself"],
    preparation:
      "Cut up strings of the ribbon and tie them onto the hulahoop so that when you spin, the ribbons spin with you.",
    "purchase link": "https://amzn.to/2SmugKR",
    link: [],
    id: "71",
  },
  "72": {
    name: "A pool of light",
    verb: ["make"],
    moods: ["creative", "visual"],
    location: ["outdoors"],
    preparationType: "Prepare materials for",
    tags: ["light", "build", "activity", "immersive"],
    ingredients: ["Cube lights", "White sheet", "Large cardboard box"],
    optionalIngredients: [],
    withWhom: ["friends", "myself"],
    preparation:
      "Cut the bottom and the top of the cardboard box out. Place the cube lights inside the remaining four walls of the box. Stretch the white sheet over the top.",
    link: [],
    id: "72",
  },
  "75": {
    name: "Akiyoshi Kitaoka's optical illusions",
    verb: ["look at"],
    moods: ["visual", "curious", "passive"],
    location: ["indoors"],
    tags: ["illusion", "visual", "look", "immersive", "screens"],
    ingredients: [],
    optionalIngredients: [],
    withWhom: ["friends", "myself"],
    preparation:
      "Open up [Akiyoshi Kitaoka's illusions](http://www.psy.ritsumei.ac.jp/~akitaoka/index-e.html) in your browser.",
    link: ["http://www.psy.ritsumei.ac.jp/~akitaoka/index-e.html"],
    id: "75",
  },
  "77": {
    name: "A sleeping stranger",
    verb: ["make"],
    moods: ["creative", "funny", "playful"],
    location: ["indoors"],
    tags: ["illusion", "activity", "immersive"],
    ingredients: ["Clothes", "Hoodie", "Shoes"],
    optionalIngredients: [
      "Paper towel rolls",
      "Toilet paper rolls",
      "Cereal boxes",
    ],
    withWhom: ["friends", "myself"],
    preparation:
      "Pick an outfit for your sleeping stranger. Make sure this stranger has a hoodie.",
    description:
      "Lay down the outfit on the couch in the shape of a sleeping person. Stuff the clothes to bring your stranger to life. Use anything from toilet paper rolls for the arms and legs to cereal boxes to give your sleeping stranger volume. Cover the head with the hood and make sure to hide feet with shoes. Let this sleeping stranger surprise others around you or let them be a trusted, albeit, sleepy  confident for your trip.",
    link: [],
    id: "77",
  },
  "78": {
    name: "Dice (maybe loads of tiny ones)",
    verb: ["play with"],
    moods: ["playful"],
    location: ["indoors"],
    preparationType: "Get",
    tags: ["material", "game"],
    ingredients: [],
    optionalIngredients: [],
    withWhom: ["friends", "myself"],
    link: [],
    id: "78",
  },
  "80": {
    name: "Josh Lambert's art",
    verb: ["look at"],
    moods: ["visual", "creative", "passive", "colorful"],
    location: ["indoors"],
    tags: ["art", "visual", "material", "look", "immersive", "screens"],
    ingredients: [],
    optionalIngredients: [],
    withWhom: ["friends", "myself"],
    preparation:
      "Open [Josh's art](http://instagram.com/lamjoshbert) in your browser.",
    link: ["http://instagram.com/lamjoshbert"],
    id: "80",
  },
  "81": {
    name: "Kirigami",
    verb: ["play with"],
    moods: ["creative", "visual", "playful", "active"],
    location: ["indoors"],
    tags: ["visual", "immersive", "light", "environment", "colors"],
    ingredients: ["Paper", "Scissors", "Colorful lights", "Lights"],
    optionalIngredients: ["Kirigami book"],
    withWhom: ["friends", "myself"],
    preparation:
      "Make some kirigami by folding a piece of paper and cutting out patterns on it. You can get inspiration from [these tutorials](http://www.tongs-paper-cutting.com/Video-Instructions.html), [this book](https://amzn.to/3zD8Fyo) or just try on your own.",
    description:
      "Dim the lights in your room and have a light source you can move around like a candle, flashlights, or cube lights. Play with moving the lights around your kirigami and watch the whole room change as the shadows move around.",
    "purchase link": "https://amzn.to/3zD8Fyo",
    link: [],
    id: "81",
  },
  "82": {
    name: "Neon dust",
    verb: ["play with"],
    moods: ["visual", "colorful", "romantic"],
    location: ["indoors"],
    preparationType: "Get",
    tags: ["colors", "environment", "visual", "messy"],
    ingredients: [],
    optionalIngredients: [],
    withWhom: ["friends"],
    description: "Paint each other's skin with neon dust.",
    "purchase link": "https://amzn.to/3gF41Za",
    link: [],
    id: "82",
  },
  "84": {
    name: "A human-sized hamster wheel",
    verb: ["play with"],
    moods: ["active", "creative"],
    location: ["outdoors"],
    preparationType: "Prepare materials for",
    tags: ["activity", "tool", "material", "illusion"],
    ingredients: ["Plywood", "Tablesaw", "Drill", "Hammer", "Measuring tape"],
    optionalIngredients: [],
    withWhom: ["friends"],
    preparation:
      "Follow [this tutorial](https://www.youtube.com/watch?v=7wKtpiPJPtM) to make a your hamster-wheel. This one is a long one!",
    description: "Get in your wheel and go while you stay in place!",
    link: [],
    id: "84",
  },
  "85": {
    name: "A Chinese finger trap",
    verb: ["play with"],
    moods: ["playful", "funny", "active"],
    location: ["outdoors", "indoors"],
    preparationType: "Prepare materials for",
    tags: ["material", "tool", "illusion", "trick", "immersive"],
    ingredients: ["Chinese finger trap"],
    optionalIngredients: [],
    withWhom: ["friends"],
    link: [],
    id: "85",
  },
  "87": {
    name: "A fish tank",
    verb: ["look at"],
    moods: ["visual", "nature-loving", "colorful"],
    location: ["indoors"],
    preparationType: "Get",
    tags: ["visual", "living thing", "water"],
    ingredients: ["A fish tank", "Fish"],
    optionalIngredients: [],
    withWhom: ["friends", "myself"],
    link: [],
    id: "87",
  },
  "88": {
    name: "Plastic spoons",
    verb: ["play with"],
    moods: ["creative"],
    location: ["indoors"],
    preparationType: "Get",
    tags: ["tool", "material", "build"],
    ingredients: ["Plastic spoons", "Glue", "Scissors"],
    optionalIngredients: [],
    withWhom: ["friends", "myself"],
    description:
      "Make a sculpture by cutting the handles of the spoons and glueing them together.",
    "purchase link": "https://amzn.to/3zO7cWj",
    link: [],
    id: "88",
  },
  "89": {
    name: "A trampoline",
    verb: ["play on"],
    moods: ["active"],
    location: ["outdoors"],
    preparationType: "Get",
    tags: ["material", "outside", "movement"],
    ingredients: ["Trampoline"],
    optionalIngredients: [],
    withWhom: ["friends", "myself"],
    "purchase link": "https://amzn.to/3zIs55c",
    link: [],
    id: "89",
  },
  "90": {
    name: "Plants",
    verb: ["touch"],
    moods: ["nature-loving", "curious", "tactile", "visual"],
    location: ["indoors", "outdoors"],
    tags: ["living thing", "texture", "nature"],
    ingredients: ["Plants"],
    optionalIngredients: [],
    withWhom: ["friends", "myself"],
    description:
      "Plants are living beings. Get close to them, really see their details, gently touch them, hold them. Give them love.",
    link: [],
    id: "90",
  },
  "91": {
    name: "Floater bowls",
    verb: ["play with"],
    moods: ["calm", "serene"],
    location: ["indoors"],
    tags: ["water", "environment", "tool", "material"],
    ingredients: ["Small bowls", "Large bowl", "Water", "Paper", "Lighter"],
    optionalIngredients: ["Food coloring"],
    withWhom: ["friends", "myself"],
    preparation:
      "Fill the large bowl with water and add food coloring if you'd like. Place the smaller bowls to float on the water. These bowls should be made of glass or metal. In each bowl, write a note you want to forget.",
    description:
      "When it feels right, set a note on fire. (Make sure you're safe! Always keep any eye on the fire and ensure it's put out.)",
    link: [],
    id: "91",
  },
  "92": {
    name: "Magnetic balls",
    verb: ["play with"],
    moods: ["playful", "curious"],
    location: ["indoors"],
    preparationType: "Get",
    tags: ["material", "illusion"],
    ingredients: ["Magnetic balls"],
    optionalIngredients: [],
    withWhom: ["friends", "myself"],
    description:
      "Electromagnetism is a fundamental force that governs how the universe works. Witness it through these magnetic balls. Feel their push and pull. Turn them into shapes.",
    "purchase link": "https://amzn.to/3gF9vDb",
    link: [
      "https://www.touchofmodern.com/sales/zen-magnets-14e0f0e2-e92a-4c6a-a56d-e8cdf486f522/micro-432",
    ],
    id: "92",
  },
  "93": {
    name: "A hologram",
    verb: ["make"],
    moods: ["creative", "curious", "active"],
    location: ["indoors"],
    preparationType: "Prepare materials for",
    tags: ["build", "illusion", "activity", "screens"],
    ingredients: ["A CD case", "Smartphone", "Exacto knife"],
    optionalIngredients: [],
    withWhom: ["friends", "myself"],
    preparation:
      "Follow [this tutorial](https://makezine.com/projects/transform-a-cd-case-into-a-hologram-illusion/)",
    description:
      "Search for a hologram video on YouTube and watch it come to life!",
    link: [
      "https://makezine.com/projects/transform-a-cd-case-into-a-hologram-illusion/",
    ],
    id: "93",
  },
  "94": {
    name: "A polaroid camera",
    verb: ["play with"],
    moods: ["social"],
    location: ["indoors", "outdoors"],
    preparationType: "Get",
    tags: ["material", "tool", "visual", "activity", "illusion"],
    ingredients: ["Polaroid camera"],
    optionalIngredients: [],
    withWhom: ["friends", "myself"],
    "purchase link": "https://amzn.to/3vGubiF",
    link: [],
    id: "94",
  },
  "95": {
    name: "Egiphany",
    verb: ["look at"],
    moods: ["visual", "passive", "cozy", "tired", "colorful"],
    location: ["indoors"],
    tags: ["tool", "screens", "visual", "look", "immersive"],
    ingredients: ["A screen"],
    optionalIngredients: [],
    withWhom: ["friends", "myself"],
    preparation:
      "Open up [Egiphany](http://egiphany.com/) on a browser. Make it full screen.",
    link: ["http://egiphany.com/"],
    id: "95",
  },
  "96": {
    name: "Glow in the dark bubbles",
    verb: ["play with"],
    moods: ["colorful", "passive", "playful"],
    location: ["indoors", "outdoors"],
    preparationType: "Get",
    tags: ["material", "visual", "immersive", "darkness"],
    ingredients: [],
    optionalIngredients: [],
    withWhom: ["friends", "myself"],
    link: [],
    id: "96",
  },
  "97": {
    name: "A ribbon obstacle course",
    verb: ["make"],
    moods: ["creative", "active", "colorful", "playful"],
    location: ["indoors", "outdoors"],
    tags: ["activity", "build", "movement"],
    ingredients: [],
    optionalIngredients: [],
    withWhom: ["friends", "myself"],
    link: [
      "https://img.buzzfeed.com/buzzfeed-static/static/2014-11/26/17/enhanced/webdr06/enhanced-7119-1417042504-13.jpg",
    ],
    id: "97",
  },
  "98": {
    name: "Meditation",
    verb: ["do"],
    moods: ["calm", "serene", "philosophical", "good"],
    location: ["indoors", "outdoors"],
    tags: ["concentration", "calm"],
    ingredients: [],
    optionalIngredients: [],
    withWhom: ["friends", "myself"],
    link: [],
    id: "98",
  },
  "99": {
    name: "A newspaper",
    verb: ["look at", "use"],
    moods: ["curious", "bad"],
    location: ["indoors"],
    preparationType: "Get",
    tags: ["tool", "material", "illusion"],
    ingredients: [],
    optionalIngredients: [],
    withWhom: ["friends", "myself"],
    link: [],
    id: "99",
  },
  "100": {
    name: "Tons of cool physics toys",
    verb: ["play with"],
    moods: ["curious", "playful", "experimental"],
    location: ["indoors"],
    preparationType: "Get",
    tags: ["tricks", "illusion", "material"],
    ingredients: [],
    optionalIngredients: [],
    withWhom: ["friends", "myself"],
    link: ["http://physicstoys.blogspot.com/"],
    id: "100",
  },
  "101": {
    name: "A zoetrope",
    verb: ["make"],
    moods: ["creative", "experimental"],
    location: ["indoors"],
    preparationType: "Get",
    tags: ["illusion", "motion", "look"],
    ingredients: [],
    optionalIngredients: [],
    withWhom: ["friends", "myself"],
    link: [],
    id: "101",
  },
  "102": {
    name: "A rattleback",
    verb: ["play with"],
    moods: ["playful", "experimental"],
    location: ["indoors"],
    preparationType: "Get",
    tags: ["material", "illusion", "play"],
    ingredients: [],
    optionalIngredients: [],
    withWhom: ["friends", "myself"],
    link: [
      "https://www.amazon.com/Rattleback-Plastic-Assorted-Colors-Teachers/dp/B004P6E984",
      " https://en.wikipedia.org/wiki/Rattleback",
    ],
    id: "102",
  },
  "103": {
    name: "Polarizing sheets",
    verb: ["use", "play with"],
    moods: ["visual", "experimental", "creative", "colorful"],
    location: ["indoors"],
    preparationType: "Get",
    tags: ["material", "colors", "light", "play", "immersive"],
    ingredients: [],
    optionalIngredients: [],
    withWhom: ["friends", "myself"],
    link: ["https://polarizingsheet.com/"],
    id: "103",
  },
  "104": {
    name: "Phasing Disks",
    verb: ["play with"],
    moods: ["creative", "curious"],
    location: ["indoors"],
    preparationType: "Get",
    tags: ["illusion", "science", "material", "colors", "light"],
    ingredients: [],
    optionalIngredients: [],
    withWhom: ["friends", "myself"],
    link: ["https://www.instagram.com/p/BO2yJ_lFVoW/"],
    note: "Phasing Disks: the result of constructive and destructive interference of light waves bouncing in between and through acrylic producing light and dark bands of iridescent colors. This kinetic art object allows for compression of the tiny gap between the disks to dynamically shift the interference patterns. Special thanks to physicsfan @instagougherty for sending me this psychedelic physics gift! Comment below if you think he should Kickstarter his Phasing Disks physics toy. ➡️ Follow the link in my profile for info on where to get many of the physics toys featured here. #Newton #IsaacNewton #NewtonsRings",
    id: "104",
  },
  "105": {
    name: "Siren Disk",
    verb: ["play with"],
    moods: ["curious", "creative", "experimental"],
    location: ["indoors"],
    preparationType: "Get",
    tags: ["build", "sound", "play", "science", "project", "activity"],
    ingredients: [],
    optionalIngredients: [],
    withWhom: ["friends", "myself"],
    link: ["https://www.exploratorium.edu/snacks/siren-disk"],
    id: "105",
  },
  "106": {
    name: "Yourself as others see you, cylindirical mirror",
    verb: ["see"],
    moods: ["curious", "experimental", "creative"],
    location: ["indoors"],
    preparationType: "Prepare materials for",
    tags: ["illusion", "build", "science", "project", "activity"],
    ingredients: [],
    optionalIngredients: [],
    withWhom: ["friends", "myself"],
    link: ["https://www.exploratorium.edu/snacks/cylindrical-mirror"],
    id: "106",
  },
  "107": {
    name: "Reflective mylar sheets",
    verb: ["use", "play with"],
    moods: ["creative", "visual", "experimental"],
    location: ["indoors"],
    preparationType: "Get",
    tags: ["illusion", "material"],
    ingredients: [],
    optionalIngredients: [],
    withWhom: ["friends", "myself"],
    link: [],
    id: "107",
  },
  "108": {
    name: "A moving image magic wand (projector required)",
    verb: ["make", "play with"],
    moods: ["creative", "experimental"],
    location: ["indoors"],
    preparationType: "Prepare materials for",
    tags: ["build", "project", "activity", "illusion", "light"],
    ingredients: [],
    optionalIngredients: [],
    withWhom: ["friends", "myself"],
    link: ["https://www.exploratorium.edu/snacks/magic-wand"],
    id: "108",
  },
  "109": {
    name: "A custom microbank optical illusion",
    verb: ["play with"],
    moods: ["experimental", "creative"],
    location: ["indoors"],
    preparationType: "Prepare materials for",
    tags: ["project", "material", "illusion", "science", "build"],
    ingredients: [],
    optionalIngredients: [],
    withWhom: ["friends", "myself"],
    link: [
      "https://www.amazon.com/Fascinations-Bank-Cube-colors-vary/dp/B000H6FM4Q/ref=sr_1_1",
    ],
    id: "109",
  },
  "110": {
    name: "A hole in your hand",
    verb: ["make"],
    moods: ["experimental"],
    location: ["indoors"],
    tags: ["project", "illusion", "activity", "science"],
    ingredients: [],
    optionalIngredients: [],
    withWhom: ["friends", "myself"],
    link: ["https://www.exploratorium.edu/snacks/hole-in-your-hand"],
    id: "110",
  },
  "111": {
    name: "Unshelled whole eggs (osmosis)",
    verb: ["play with"],
    moods: ["experimental"],
    location: ["indoors"],
    preparationType: "Make",
    tags: ["science", "project", "illusion"],
    ingredients: [],
    optionalIngredients: [],
    withWhom: ["friends", "myself"],
    link: [
      "http://www.exploratorium.edu/cooking/eggs/activity-nakedexperiment.html",
    ],
    id: "111",
  },
  "112": {
    name: "Crystals",
    verb: ["play with", "use"],
    moods: ["colorful", "immersive"],
    location: ["indoors"],
    preparationType: "Get",
    tags: ["material", "colors", "science", "project", "activity"],
    ingredients: [],
    optionalIngredients: [],
    withWhom: ["friends", "myself"],
    link: ["http://www.exploratorium.edu/science_explorer/crystal.html"],
    id: "112",
  },
  "113": {
    name: "Persistence of vision",
    verb: ["play with"],
    moods: ["experimental"],
    location: ["indoors"],
    tags: ["activity", "illusion", "science", "project"],
    ingredients: [],
    optionalIngredients: [],
    withWhom: ["friends", "myself"],
    link: ["https://www.exploratorium.edu/snacks/persistence-of-vision"],
    id: "113",
  },
  "114": {
    name: "A temperature-sensitive liquid crystal material",
    verb: ["play with"],
    moods: ["playful", "curious"],
    location: ["indoors"],
    preparationType: "Get",
    tags: ["material", "illusion", "play", "colors"],
    ingredients: [],
    optionalIngredients: [],
    withWhom: ["friends", "myself"],
    link: [
      "https://www.sciplus.com/liquid-crystal-sheet-temperature-sensitive-sheet-3676-p",
    ],
    id: "114",
  },
  "115": {
    name: "Colored shadows",
    verb: ["play with"],
    moods: ["colorful", "experimental"],
    location: ["indoors"],
    tags: ["colors"],
    ingredients: [],
    optionalIngredients: [],
    withWhom: ["friends", "myself"],
    link: ["https://www.exploratorium.edu/snacks/colored-shadows"],
    id: "115",
  },
  "116": {
    name: "music with your teeth",
    verb: ["listen to"],
    moods: ["experimental", "auditory"],
    location: ["indoors"],
    tags: ["sound", "music", "illusion", "project", "science"],
    ingredients: [],
    optionalIngredients: [],
    withWhom: ["friends", "myself"],
    link: ["https://www.exploratorium.edu/snacks/sound-bite"],
    id: "116",
  },
  "117": {
    name: "A vacuumed trash bag",
    verb: ["play with", "get inside"],
    moods: ["experimental", "social", "playful", "funny"],
    location: ["indoors"],
    tags: ["texture", "funny", "activity"],
    ingredients: [],
    optionalIngredients: [],
    withWhom: ["friends"],
    link: ["https://www.exploratorium.edu/snacks/feeling-pressured"],
    id: "117",
  },
  "118": {
    name: "A flying tinsel",
    verb: ["play with", "make"],
    moods: ["experimental", "playful"],
    location: ["indoors"],
    preparationType: "Get",
    tags: ["illusion", "project", "science"],
    ingredients: [],
    optionalIngredients: [],
    withWhom: ["friends", "myself"],
    link: ["https://www.exploratorium.edu/snacks/flying-tinsel"],
    id: "118",
  },
  "119": {
    name: "Periscope",
    verb: ["play wih", "use"],
    moods: ["experimental", "creative"],
    location: ["indoors"],
    preparationType: "Get",
    tags: ["build", "science", "illusion", "project"],
    ingredients: [],
    optionalIngredients: [],
    withWhom: ["friends", "myself"],
    link: ["http://www.exploratorium.edu/science_explorer/periscope.html"],
    id: "119",
  },
  "120": {
    name: "A long exposure light painting",
    verb: ["make"],
    moods: ["colorful", "experimental"],
    location: ["indoors", "outdoors"],
    tags: ["light", "visual", "darkness", "activity"],
    ingredients: [],
    optionalIngredients: [],
    withWhom: ["friends", "myself"],
    link: [],
    id: "120",
  },
  "121": {
    name: "A hand battery",
    verb: ["make"],
    moods: ["experimental"],
    location: ["indoors"],
    preparationType: "Prepare materials for",
    tags: ["project", "science", "illusion"],
    ingredients: [],
    optionalIngredients: [],
    withWhom: ["friends", "myself"],
    link: ["https://www.exploratorium.edu/snacks/hand-battery"],
    id: "121",
  },
  "122": {
    name: "Mirror Anamorphosis (cylindrical mirror reveals something in art)",
    verb: ["play with"],
    moods: ["creative"],
    location: ["indoors"],
    preparationType: "Prepare materials for",
    tags: ["illusion", "look", "material"],
    ingredients: [],
    optionalIngredients: [],
    withWhom: ["friends", "myself"],
    link: ["https://en.wikipedia.org/wiki/Anamorphosis"],
    id: "122",
  },
  "123": {
    name: "A vocal visualizer",
    verb: ["play with"],
    moods: ["auditory", "experimental"],
    location: ["indoors"],
    preparationType: "Prepare materials for",
    tags: ["sound", "visual", "build", "light", "illusion", "project"],
    ingredients: [],
    optionalIngredients: [],
    withWhom: ["friends", "myself"],
    link: ["https://www.exploratorium.edu/snacks/vocal-visualizer"],
    id: "123",
  },
  "124": {
    name: "Stacking up sticks",
    verb: ["use", "play with"],
    moods: ["experimental"],
    location: ["indoors"],
    preparationType: "Prepare materials for",
    tags: ["build", "science", "project", "physics"],
    ingredients: [],
    optionalIngredients: [],
    withWhom: ["friends", "myself"],
    link: ["https://www.exploratorium.edu/snacks/take-it-from-top"],
    id: "124",
  },
  "125": {
    name: "Locating sound",
    verb: ["play with"],
    moods: ["experimental"],
    location: ["indoors", "outdoors"],
    preparationType: "Prepare materials for",
    tags: ["sound", "project", "activity", "illusion"],
    ingredients: [],
    optionalIngredients: [],
    withWhom: ["friends"],
    link: ["https://www.exploratorium.edu/snacks/stereo-sound"],
    note: "http://www.exploratorium.edu/listen/activities/dean/localize/lg_dean_localize.php",
    id: "125",
  },
  "126": {
    name: "invisibility",
    verb: ["play with"],
    moods: ["experimental", "mysterious"],
    location: ["indoors"],
    tags: ["illusion", "activity"],
    ingredients: [],
    optionalIngredients: [],
    withWhom: ["friends", "myself"],
    link: ["https://www.exploratorium.edu/snacks/cheshire-cat"],
    id: "126",
  },
  "127": {
    name: "Colored filters",
    verb: ["play with", "use"],
    moods: ["colorful", "visual"],
    location: ["indoors"],
    preparationType: "Get",
    tags: ["colors", "material"],
    ingredients: [],
    optionalIngredients: [],
    withWhom: ["friends", "myself"],
    link: [],
    id: "127",
  },
  "128": {
    name: "Polarized light mosaic",
    verb: ["play with"],
    moods: ["colorful", "visual", "experimental"],
    location: ["indoors"],
    preparationType: "Prepare materials for",
    tags: ["material", "colors", "light", "visual"],
    ingredients: [],
    optionalIngredients: [],
    withWhom: ["friends", "myself"],
    link: ["https://www.exploratorium.edu/snacks/polarized-light-mosaic"],
    id: "128",
  },
  "129": {
    name: "Infinity mirror (using partially mirrored panes of glass)",
    verb: ["make"],
    moods: ["experimental"],
    location: ["indoors"],
    preparationType: "Prepare materials for",
    tags: ["build", "material", "immersive", "illusion"],
    ingredients: [],
    optionalIngredients: [],
    withWhom: ["friends", "myself"],
    link: ["https://www.instagram.com/p/BNCihUUhqcn/"],
    id: "129",
  },
  "130": {
    name: "Silica aerogel",
    verb: ["play with", "use"],
    moods: ["curious", "tactile", "experimental"],
    location: ["indoors"],
    preparationType: "Get",
    tags: ["material", "illusion"],
    ingredients: [],
    optionalIngredients: [],
    withWhom: ["friends", "myself"],
    link: ["https://www.instagram.com/p/BVP-dHKFlXa/?taken-by=physicsfun"],
    id: "130",
  },
  "131": {
    name: "A magnifier",
    verb: ["play with"],
    moods: ["visual"],
    location: ["indoors"],
    preparationType: "Get",
    tags: ["material", "tool", "illusion"],
    ingredients: [],
    optionalIngredients: [],
    withWhom: ["friends", "myself"],
    link: [],
    id: "131",
  },
  "132": {
    name: "Telescope",
    verb: ["play with", "look through"],
    moods: ["visual", "vast", "curious"],
    location: ["indoors", "outdoors"],
    preparationType: "Get",
    tags: ["tool", "sky", "darkness", "outside", "night", "visual", "space"],
    ingredients: [],
    optionalIngredients: [],
    withWhom: ["friends", "myself"],
    link: [],
    "time of the day": "night",
    id: "132",
  },
  "133": {
    name: "A microscope",
    verb: ["look through", "play with", "use"],
    moods: ["curious", "experimental"],
    location: ["indoors"],
    preparationType: "Get",
    tags: ["tool", "science", "discovery"],
    ingredients: [],
    optionalIngredients: [],
    withWhom: ["friends", "myself"],
    link: [],
    id: "133",
  },
  "134": {
    name: "Disco ball",
    verb: ["use", "look at"],
    moods: ["visual", "immersive"],
    location: ["indoors"],
    preparationType: "Get",
    tags: ["material", "light", "illusion"],
    ingredients: [],
    optionalIngredients: [],
    withWhom: ["friends", "myself"],
    link: [],
    id: "134",
  },
  "135": {
    name: "Compass",
    verb: ["use"],
    moods: ["experimental", "exploratory"],
    location: ["outdoors"],
    preparationType: "Get",
    tags: ["material", "tool"],
    ingredients: [],
    optionalIngredients: [],
    withWhom: ["friends", "myself"],
    link: [],
    id: "135",
  },
  "136": {
    name: "Cool rocks",
    verb: ["find"],
    moods: ["playful", "exploratory", "curious"],
    location: ["outdoors"],
    tags: ["material", "nature"],
    ingredients: [],
    optionalIngredients: [],
    withWhom: ["friends", "myself"],
    link: [],
    id: "136",
  },
  "138": {
    name: "Toy blocks",
    verb: ["play with"],
    moods: ["playful"],
    location: ["indoors"],
    preparationType: "Get",
    tags: ["build", "activity", "material"],
    ingredients: [],
    optionalIngredients: [],
    withWhom: ["friends", "myself"],
    link: ["https://thegadgetflow.com/portfolio/portable-toy-box/"],
    id: "138",
  },
  "139": {
    name: "A floating desk object",
    verb: ["play with", "make"],
    moods: ["experimental"],
    location: ["indoors"],
    preparationType: "Prepare materials for",
    tags: ["illusion", "material", "project"],
    ingredients: [],
    optionalIngredients: [],
    withWhom: ["friends", "myself"],
    link: ["https://thegadgetflow.com/portfolio/floating-desk-object/"],
    id: "139",
  },
  "140": {
    name: "Predictive text on your phone keyboard (e.g. type “Tonight we” and keep choosing 1st suggestion on keyboard til nonsense)",
    verb: ["play with"],
    moods: ["passive", "social", "playful", "technological"],
    location: ["indoors"],
    tags: ["activity", "screens"],
    ingredients: [],
    optionalIngredients: [],
    withWhom: ["friends", "myself"],
    link: [],
    id: "140",
  },
  "141": {
    name: "Components/mechanics",
    verb: ["contemplate"],
    moods: ["inellectual", "passive"],
    location: ["indoors"],
    tags: ["category"],
    ingredients: [],
    optionalIngredients: [],
    withWhom: ["friends", "myself"],
    link: [],
    id: "141",
  },
  "142": {
    name: "A rule where you can’t say a word/refer to a concept",
    verb: ["play with", "make"],
    moods: ["social", "experimental"],
    location: ["indoors", "outdoors"],
    tags: ["activity", "ceremony", "idea"],
    ingredients: [],
    optionalIngredients: [],
    withWhom: ["friends"],
    link: [],
    id: "142",
  },
  "143": {
    name: "A passing stranger and get their answer to _______”",
    verb: ["find"],
    moods: ["social"],
    location: ["outdoors"],
    tags: ["activity", "ceremony", "idea"],
    ingredients: [],
    optionalIngredients: [],
    withWhom: ["friends"],
    link: [],
    id: "143",
  },
  "144": {
    name: "A passageway in house can have like a high five every time you pass through it",
    verb: ["play with", "adorn"],
    moods: ["ceremonial", "congratulatory", "self improvement focused"],
    location: ["indoors"],
    tags: ["immersive", "reminder", "ceremony"],
    ingredients: [],
    optionalIngredients: [],
    withWhom: ["friends", "myself"],
    link: [],
    id: "144",
  },
  "145": {
    name: "Two person clothing, two person yoga",
    verb: ["play with", "make"],
    moods: ["romantic", "playful", "cozy"],
    location: ["indoors", "outdoors"],
    tags: ["activity", "romance", "movement", "unusual"],
    ingredients: [],
    optionalIngredients: [],
    withWhom: ["friends", "myself", "my partner"],
    link: [],
    note: "Could just be a few select large elastic ribbons you attach certain points to",
    id: "145",
  },
  "146": {
    name: "A group activity where you find assumptions that you don’t share, maybe go to a mountain have a picnic over it",
    verb: ["do"],
    moods: ["social"],
    location: ["indoors", "outdoors"],
    tags: ["activity", "conversation", "discovery", "intellectual"],
    ingredients: [],
    optionalIngredients: [],
    withWhom: ["friends"],
    link: [],
    id: "146",
  },
  "148": {
    name: "A map of your house as something else (e.g. Surrealist Home)",
    verb: ["make", "draw"],
    moods: ["creative", "playful", "artsy"],
    location: ["indoors"],
    tags: ["activity", "creative", "intellectual"],
    ingredients: [],
    optionalIngredients: [],
    withWhom: ["friends", "myself"],
    link: [],
    id: "148",
  },
  "149": {
    name: "A really oppressive (constricting, heavy, etc) article of clothing that you carry for a while and then symbolically shed when a burden is lifted at some defined point in the trip",
    verb: ["use"],
    moods: ["experiential"],
    location: ["indoors", "outdoors"],
    tags: ["texture", "ceremony", "idea", "change"],
    ingredients: [],
    optionalIngredients: [],
    withWhom: ["friends", "myself"],
    link: [],
    id: "149",
  },
  "150": {
    name: "A blanket fort",
    verb: ["make"],
    moods: ["cozy", "romantic"],
    location: ["indoors"],
    tags: ["cozy", "comfort", "activity", "immersive", "environment"],
    ingredients: [],
    optionalIngredients: [],
    withWhom: ["friends", "myself"],
    link: [],
    id: "150",
  },
  "151": {
    name: "Fabric off a 3d surface on the wall (making an altar?)",
    verb: ["hang"],
    moods: ["immersive", "cozy"],
    location: ["indoors"],
    preparationType: "Prepare materials for",
    tags: ["environment", "cozy", "ceremony"],
    ingredients: [],
    optionalIngredients: [],
    withWhom: ["friends", "myself"],
    link: [],
    id: "151",
  },
  "152": {
    name: "Environments based on cities in invisible cities",
    verb: ["make", "contemplate", "come up with"],
    moods: ["pensive", "philosophical", "creative"],
    location: ["indoors"],
    preparationType: "Prepare materials for",
    tags: ["idea", "environment"],
    ingredients: [],
    optionalIngredients: [],
    withWhom: ["friends", "myself"],
    link: [],
    id: "152",
  },
  "153": {
    name: "A fish (in real life) before you give yourself permission to to something you've been wanting to do",
    verb: ["Catch"],
    moods: ["ceremonial"],
    location: ["outdoors"],
    tags: ["activity", "reminder", "change", "long time"],
    ingredients: [],
    optionalIngredients: [],
    withWhom: ["friends", "myself"],
    link: [],
    id: "153",
  },
  "154": {
    name: "Places from a strong childhood/past memory",
    verb: ["find", "contemplate", "remember"],
    moods: ["nostalgic", "social", "cozy"],
    location: ["indoors", "outdoors"],
    tags: ["discovery", "childhood", "remembering", "memories"],
    ingredients: [],
    optionalIngredients: [],
    withWhom: ["friends", "myself"],
    link: [],
    id: "154",
  },
  "155": {
    name: "A paper stalagmite sculpture/pathway",
    verb: ["make"],
    moods: ["creative", "active"],
    location: ["indoors", "outdoors"],
    tags: ["environment", "immersive"],
    ingredients: [],
    optionalIngredients: [],
    withWhom: ["friends", "myself"],
    link: [],
    id: "155",
  },
  "156": {
    name: "your body into a string instrument",
    verb: ["turn"],
    moods: ["creative", "auditory", "experimental"],
    location: ["indoors"],
    preparationType: "Prepare materials for",
    tags: ["activity", "sound", "music", "romance"],
    ingredients: [],
    optionalIngredients: [],
    withWhom: ["friends", "my partner"],
    link: [],
    id: "156",
  },
  "157": {
    name: "Body adornments (clothing, jewelry, other stuff)",
    verb: ["use", "play with"],
    moods: ["creative", "social", "playful", "solitary"],
    location: ["indoors"],
    tags: ["material", "texture", "romance"],
    ingredients: [],
    optionalIngredients: [],
    withWhom: ["friends", "myself", "my partner"],
    link: [],
    id: "157",
  },
  "158": {
    name: "Cups that are connected by tubes so that one raised causes the other to overflow - tea party!",
    verb: ["play with", "make"],
    moods: ["playful", "funny", "social", "experimental"],
    location: ["indoors"],
    preparationType: "Prepare materials for",
    tags: ["activity", "unusual", "messy"],
    ingredients: [],
    optionalIngredients: [],
    withWhom: ["friends"],
    link: [],
    id: "158",
  },
  "159": {
    name: "A DIY sculpture with tent poles and some segments covered in translucent stuff",
    verb: ["make"],
    moods: ["creative", "social", "immersive"],
    location: ["indoors"],
    preparationType: "Prepare materials for",
    tags: ["build", "immersive", "environment", "project", "creative"],
    ingredients: [],
    optionalIngredients: [],
    withWhom: ["friends"],
    link: [],
    id: "159",
  },
  "160": {
    name: "Cool stuff on your ceiling",
    verb: ["hang"],
    moods: ["cozy", "immersive", "artsy"],
    location: ["indoors"],
    tags: ["environment", "immersive"],
    ingredients: [],
    optionalIngredients: [],
    withWhom: ["friends", "myself"],
    link: [],
    id: "160",
  },
  "161": {
    name: "Clouds from your ceiling",
    verb: ["make"],
    moods: ["cozy", "creative", "immersive", "solitary", "social"],
    location: ["indoors"],
    preparationType: "Prepare materials for",
    tags: ["environment", "immersive"],
    ingredients: [],
    optionalIngredients: [],
    withWhom: ["friends", "myself"],
    link: [],
    id: "161",
  },
  "162": {
    name: "Some thing(s) from the ceiling at head height",
    verb: ["hang"],
    moods: ["immersive", "creative", "cozy"],
    location: ["indoors"],
    preparationType: "Prepare materials for",
    tags: ["environment", "immersive", "texture", "colors"],
    ingredients: [],
    optionalIngredients: [],
    withWhom: ["friends", "myself"],
    link: [],
    id: "162",
  },
  "163": {
    name: "Hedgemaze/labyrinth",
    verb: ["build"],
    moods: ["playful", "creative", "active", "philosophical"],
    location: ["indoors", "outdoors"],
    tags: ["environment", "immersive", "ceremony"],
    ingredients: [],
    optionalIngredients: [],
    withWhom: ["friends", "myself"],
    link: [],
    id: "163",
  },
  "164": {
    name: "Twister with lights everyone has a color, something with overlaps and rules",
    verb: ["play with"],
    moods: ["playful", "social"],
    location: ["indoors"],
    preparationType: "Prepare materials for",
    tags: ["game", "colors", "sensual", "movement", "activity"],
    ingredients: [],
    optionalIngredients: [],
    withWhom: ["friends"],
    link: [],
    id: "164",
  },
  "165": {
    name: "Unusual textures (to cut)",
    verb: ["touch", "play with"],
    moods: ["tactile", "playful", "creative", "artsy"],
    location: ["indoors", "outdoors"],
    tags: ["texture", "material"],
    ingredients: [],
    optionalIngredients: [],
    withWhom: ["friends", "myself"],
    link: [],
    id: "165",
  },
  "166": {
    name: "A mark as you travel",
    verb: ["leave"],
    moods: ["ceremonial"],
    location: ["outdoors"],
    tags: ["ceremony", "remembering", "intellectual", "change"],
    ingredients: [],
    optionalIngredients: [],
    withWhom: ["friends", "myself"],
    link: [],
    id: "166",
  },
  "167": {
    name: "An altar that you continually add things too",
    verb: ["build"],
    moods: ["ceremonial", "important", "pensive"],
    location: ["indoors", "outdoors"],
    tags: ["ceremony", "intellectual"],
    ingredients: [],
    optionalIngredients: [],
    withWhom: ["friends", "myself"],
    link: [],
    id: "167",
  },
  "168": {
    name: "Fabric tunnel",
    verb: ["make"],
    moods: ["cozy", "creative", "romantic", "social"],
    location: ["indoors"],
    preparationType: "Prepare materials for",
    tags: ["fabric", "immersive", "cozy", "environment"],
    ingredients: [],
    optionalIngredients: [],
    withWhom: ["friends", "myself"],
    link: [],
    id: "168",
  },
  "169": {
    name: "Poe motion  (could hang around a trampoline so as you jump it all moves)",
    verb: ["play with"],
    moods: ["immersive", "visual", "playful"],
    location: ["indoors", "outdoors"],
    preparationType: "Get",
    tags: ["illusion", "environment", "immersive", "activity", "visual"],
    ingredients: [],
    optionalIngredients: [],
    withWhom: ["friends", "myself"],
    link: ["https://wp.vlthemes.com/sixten/portfolio/poemotion-book/"],
    id: "169",
  },
  "170": {
    name: "Bigger version of one of those boxes that lock/open in specific ways",
    verb: ["build", "play with"],
    moods: ["playful", "curious", "active"],
    location: ["indoors"],
    tags: ["material", "ceremony", "discovery"],
    ingredients: [],
    optionalIngredients: [],
    withWhom: ["friends", "myself"],
    link: [],
    id: "170",
  },
  "171": {
    name: "The prisoner’s dilemma",
    verb: ["contemplate"],
    moods: ["philosophical"],
    location: ["indoors"],
    tags: ["theme", "look up"],
    ingredients: [],
    optionalIngredients: [],
    withWhom: ["friends", "myself"],
    link: [],
    id: "171",
  },
  "172": {
    name: "Retrocausality",
    verb: ["contemplate"],
    moods: ["philosophical", "curious"],
    location: ["indoors"],
    tags: ["theme", "intellectual", "look up"],
    ingredients: [],
    optionalIngredients: [],
    withWhom: ["friends", "myself"],
    link: [],
    id: "172",
  },
  "173": {
    name: "Answering a series of questions/prompts that don’t really make sense in the order asked, but once they’re assembled, you’ve told a story (retrocausality!)",
    verb: ["play with", "use"],
    moods: ["social", "inquisitive", "curious"],
    location: ["indoors"],
    tags: ["activity"],
    ingredients: [],
    optionalIngredients: [],
    withWhom: ["friends", "myself"],
    link: [],
    id: "173",
  },
  "174": {
    name: "(Strange) loops",
    verb: ["contemplate"],
    moods: ["curious", "philosophical"],
    location: ["indoors"],
    tags: ["theme", "intellectual", "look up"],
    ingredients: [],
    optionalIngredients: [],
    withWhom: ["friends", "myself"],
    link: [],
    id: "174",
  },
  "175": {
    name: "Noncomplementary behavior",
    verb: ["contemplate", "use"],
    moods: ["curious", "philosophical"],
    location: ["indoors"],
    tags: ["theme", "activity", "look up"],
    ingredients: [],
    optionalIngredients: [],
    withWhom: ["friends", "myself"],
    link: [],
    id: "175",
  },
  "176": {
    name: "Intuition pumps",
    verb: ["use", "contemplate"],
    moods: ["philosophical", "curious"],
    location: ["indoors"],
    tags: ["theme", "intellectual", "look up"],
    ingredients: [],
    optionalIngredients: [],
    withWhom: ["friends", "myself"],
    link: [],
    id: "176",
  },
  "177": {
    name: "Frames, mirrors and screens",
    verb: ["use", "play with"],
    moods: ["visual", "creative", "immersive"],
    location: ["indoors"],
    preparationType: "Get",
    tags: ["illusion", "immersive", "environment", "look"],
    ingredients: [],
    optionalIngredients: [],
    withWhom: ["friends", "myself"],
    link: [],
    id: "177",
  },
  "180": {
    name: "Choose your own adventure",
    verb: ["use"],
    moods: ["creative"],
    location: ["indoors", "outdoors"],
    tags: ["theme"],
    ingredients: [],
    optionalIngredients: [],
    withWhom: ["friends", "myself"],
    link: [],
    id: "180",
  },
  "181": {
    name: "A list of questions designed to ask at predefined checkpoints geared towards unmasking other participants assumptions",
    verb: ["use", "play with"],
    moods: ["social", "solitary", "inquisitive", "pensive"],
    location: ["indoors"],
    tags: ["activity", "conversation"],
    ingredients: [],
    optionalIngredients: [],
    withWhom: ["friends"],
    link: [],
    id: "181",
  },
  "182": {
    name: "Concrete poetry/shape poetry",
    verb: ["play with"],
    moods: ["creative", "artsy"],
    location: ["indoors"],
    tags: ["activity"],
    ingredients: [],
    optionalIngredients: [],
    withWhom: ["friends", "myself"],
    link: [],
    id: "182",
  },
  "183": {
    name: "Yourself speaking (certain things) and then listen to it",
    verb: ["record"],
    moods: ["social", "solitary", "auditory", "philosophical"],
    location: ["indoors"],
    tags: ["activity", "conversation"],
    ingredients: [],
    optionalIngredients: [],
    withWhom: ["friends", "myself"],
    link: [],
    id: "183",
  },
  "184": {
    name: "Ongoing debates with friend(s)",
    verb: ["settle"],
    moods: ["social", "philosophical"],
    location: ["indoors"],
    tags: ["conversation"],
    ingredients: [],
    optionalIngredients: [],
    withWhom: ["friends"],
    link: [],
    id: "184",
  },
  "185": {
    name: "Metaphors",
    verb: ["contemplate", "use"],
    moods: ["philosophical"],
    location: ["indoors"],
    tags: ["theme"],
    ingredients: [],
    optionalIngredients: [],
    withWhom: ["friends", "myself"],
    link: [],
    id: "185",
  },
  "186": {
    name: "Pataphors",
    verb: ["contemplate", "use"],
    moods: ["philosophical"],
    location: ["indoors"],
    tags: ["theme"],
    ingredients: [],
    optionalIngredients: [],
    withWhom: ["friends", "myself"],
    link: [],
    id: "186",
  },
  "187": {
    name: "Autonyms",
    verb: ["contemplate", "use"],
    moods: ["philosophical"],
    location: ["indoors"],
    tags: ["theme", "look up"],
    ingredients: [],
    optionalIngredients: [],
    withWhom: ["friends", "myself"],
    link: [],
    id: "187",
  },
  "188": {
    name: "Presupposition",
    verb: ["contemplate"],
    moods: ["philosophical"],
    location: ["indoors"],
    tags: ["theme", "look up"],
    ingredients: [],
    optionalIngredients: [],
    withWhom: ["friends", "myself"],
    link: [],
    id: "188",
  },
  "189": {
    name: "Self-refuting ideas",
    verb: ["contemplate"],
    moods: ["philosophical"],
    location: ["indoors"],
    tags: ["theme", "look up"],
    ingredients: [],
    optionalIngredients: [],
    withWhom: ["friends", "myself"],
    link: [],
    id: "189",
  },
  "190": {
    name: "Presumption in law",
    verb: ["contemplate"],
    moods: ["philosophical"],
    location: ["indoors"],
    tags: ["theme", "look up"],
    ingredients: [],
    optionalIngredients: [],
    withWhom: ["friends", "myself"],
    link: [],
    id: "190",
  },
  "191": {
    name: "A personalized children’s book from collected childhood experiences",
    verb: ["make"],
    moods: ["nostalgic", "creative"],
    location: ["indoors"],
    tags: ["activity", "memories", "childhood"],
    ingredients: [],
    optionalIngredients: [],
    withWhom: ["friends", "myself"],
    link: [],
    id: "191",
  },
  "192": {
    name: "A podcast",
    verb: ["make"],
    moods: ["talkative", "philosophical", "social", "solitary"],
    location: ["indoors"],
    tags: ["activity", "conversation", "screens"],
    ingredients: [],
    optionalIngredients: [],
    withWhom: ["friends", "myself"],
    link: [],
    id: "192",
  },
  "193": {
    name: "A documentary",
    verb: ["make"],
    moods: ["curious", "active", "social", "solitary", "creative"],
    location: ["indoors", "outdoors"],
    tags: ["activity", "creative", "screens"],
    ingredients: [],
    optionalIngredients: [],
    withWhom: ["friends", "myself"],
    link: [],
    id: "193",
  },
  "194": {
    name: "Writing things backwards",
    verb: ["try"],
    moods: ["playful", "solitary"],
    location: ["indoors"],
    tags: ["activity", "ceremony"],
    ingredients: [],
    optionalIngredients: [],
    withWhom: ["myself"],
    link: [],
    id: "194",
  },
  "195": {
    name: "A bucket list (together?)",
    verb: ["create"],
    moods: ["social", "solitary", "adventurous", "future-looking", "romantic"],
    location: ["indoors"],
    tags: ["activity", "romance"],
    ingredients: [],
    optionalIngredients: [],
    withWhom: ["friends", "my partner"],
    link: [],
    id: "195",
  },
  "196": {
    name: "Chalk",
    verb: ["use", "play with"],
    moods: ["creative", "playful", "artsy"],
    location: ["outdoors"],
    preparationType: "Get",
    tags: ["material", "tool", "outside"],
    ingredients: [],
    optionalIngredients: [],
    withWhom: ["friends", "myself"],
    link: [],
    id: "196",
  },
  "197": {
    name: "Doppler effect",
    verb: ["contemplate"],
    moods: ["philosophical", "creative", "auditory"],
    location: ["indoors"],
    tags: ["sound", "illusion", "look up"],
    ingredients: [],
    optionalIngredients: [],
    withWhom: ["friends", "myself"],
    link: [],
    id: "197",
  },
  "198": {
    name: "Sensory experiences for each other, e.g. each person prepares 1 thing each for each 5 senses that all go together in some way (plus maybe one more e.g. proprioception (“be in this pose”) or balance (“do this movement”) there are more than 5 senses)",
    verb: ["create"],
    moods: ["romantic", "social", "playful", "experiential"],
    location: ["indoors"],
    tags: ["activity", "romance"],
    ingredients: [],
    optionalIngredients: [],
    withWhom: ["friends", "my partner"],
    link: [],
    id: "198",
  },
  "199": {
    name: "Floor is lava",
    verb: ["play"],
    moods: ["playful", "social"],
    location: ["indoors", "outdoors"],
    tags: ["theme"],
    ingredients: [],
    optionalIngredients: [],
    withWhom: ["friends", "myself"],
    link: [],
    id: "199",
  },
  "200": {
    name: "“Ship of Theseus” (“Theseus and the Minotaur”)",
    verb: ["contemplate"],
    moods: ["philosophical", "curious"],
    location: ["indoors"],
    tags: ["theme", "intellectual", "look up"],
    ingredients: [],
    optionalIngredients: [],
    withWhom: ["friends", "myself"],
    link: [],
    id: "200",
  },
  "201": {
    name: "“Churning of the Ocean of Milk”",
    verb: ["contemplate"],
    moods: ["philosophical", "artsy"],
    location: ["indoors"],
    tags: ["theme", "metaphor", "look up"],
    ingredients: [],
    optionalIngredients: [],
    withWhom: ["friends", "myself"],
    link: [],
    id: "201",
  },
  "202": {
    name: "Borges’s Library of Babel",
    verb: ["read", "contemplate"],
    moods: ["curious", "philosophical"],
    location: ["indoors"],
    tags: ["theme", "look up"],
    ingredients: [],
    optionalIngredients: [],
    withWhom: ["friends", "myself"],
    link: [],
    id: "202",
  },
  "203": {
    name: "The Chinese room",
    verb: ["contemplate"],
    moods: ["philosophical"],
    location: ["indoors"],
    tags: ["theme", "look up"],
    ingredients: [],
    optionalIngredients: [],
    withWhom: ["friends", "myself"],
    link: [],
    id: "203",
  },
  "204": {
    name: "Invisible cities",
    verb: ["read", "contemplate"],
    moods: ["philosophical", "curious"],
    location: ["indoors"],
    tags: ["theme", "look up"],
    ingredients: [],
    optionalIngredients: [],
    withWhom: ["friends", "myself"],
    link: [],
    id: "204",
  },
  "205": {
    name: "Planescape realms",
    verb: ["imagine", "contemplate"],
    moods: ["curious", "creative"],
    location: ["indoors"],
    tags: ["theme", "look up"],
    ingredients: [],
    optionalIngredients: [],
    withWhom: ["friends", "myself"],
    link: [],
    id: "205",
  },
  "206": {
    name: "The 2nd law of thermodynamics",
    verb: ["contemplate"],
    moods: ["philosophical", "curious"],
    location: ["indoors"],
    tags: ["theme", "look up"],
    ingredients: [],
    optionalIngredients: [],
    withWhom: ["friends", "myself"],
    link: [],
    id: "206",
  },
  "207": {
    name: "Maxwell’s Demon",
    verb: ["contemplate"],
    moods: ["philosophical"],
    location: ["indoors"],
    tags: ["theme", "look up"],
    ingredients: [],
    optionalIngredients: [],
    withWhom: ["friends", "myself"],
    link: [],
    id: "207",
  },
  "208": {
    name: "The Boltzmann brain",
    verb: ["contemplate"],
    moods: ["philosophical"],
    location: ["indoors"],
    tags: ["theme", "look up"],
    ingredients: [],
    optionalIngredients: [],
    withWhom: ["friends", "myself"],
    link: [],
    id: "208",
  },
  "209": {
    name: "Osmosis",
    verb: ["contemplate", "play with"],
    moods: ["creative", "philosophical"],
    location: ["indoors"],
    tags: ["theme", "look up"],
    ingredients: [],
    optionalIngredients: [],
    withWhom: ["friends", "myself"],
    link: [],
    id: "209",
  },
  "210": {
    name: "The Fermi paradox (individual explanations)",
    verb: ["contemplate"],
    moods: ["philosophical"],
    location: ["indoors"],
    tags: ["theme", "space", "look up"],
    ingredients: [],
    optionalIngredients: [],
    withWhom: ["friends", "myself"],
    link: [],
    id: "210",
  },
  "211": {
    name: "The Evil God Challenge/theodicy - one participant has to interpret if another is evil or not omnibenevolent/iscient/potent",
    verb: ["do"],
    moods: ["philosophical", "playful", "social"],
    location: ["indoors"],
    tags: ["theme", "intellectual", "belief", "look up"],
    ingredients: [],
    optionalIngredients: [],
    withWhom: ["friends", "myself"],
    link: ["https://en.wikipedia.org/wiki/Evil_God_Challenge"],
    id: "211",
  },
  "212": {
    name: "Saturday Morning Breakfast Cereal",
    verb: ["contemplate"],
    moods: ["philosophical"],
    location: ["indoors"],
    tags: ["theme", "intellectual", "belief", "screens"],
    ingredients: [],
    optionalIngredients: [],
    withWhom: ["friends", "myself"],
    link: ["http://www.smbc-comics.com/?id=2292"],
    id: "212",
  },
  "213": {
    name: "Cogito ergo sum (you have to prove you exist)",
    verb: ["contemplate"],
    moods: ["philosophical"],
    location: ["indoors"],
    tags: ["theme", "activity", "look up"],
    ingredients: [],
    optionalIngredients: [],
    withWhom: ["friends", "myself"],
    link: [],
    id: "213",
  },
  "214": {
    name: "Kavka's toxin puzzle",
    verb: ["contemplate"],
    moods: ["philosophical"],
    location: ["indoors"],
    tags: ["theme", "ceremony", "look up"],
    ingredients: [],
    optionalIngredients: [],
    withWhom: ["friends", "myself"],
    link: [],
    id: "214",
  },
  "215": {
    name: "Rawls’s Original position",
    verb: ["contemplate"],
    moods: ["philosophical"],
    location: ["indoors"],
    tags: ["theme", "activity", "conversation", "look up"],
    ingredients: [],
    optionalIngredients: [],
    withWhom: ["friends"],
    link: [],
    id: "215",
  },
  "216": {
    name: "Utility monster",
    verb: ["contemplate"],
    moods: ["philosophical"],
    location: ["indoors"],
    tags: ["theme", "look up"],
    ingredients: [],
    optionalIngredients: [],
    withWhom: ["friends", "myself"],
    link: [],
    id: "216",
  },
  "217": {
    name: "Godel’s incompleteness theorem",
    verb: ["contemplate"],
    moods: ["philosophical"],
    location: ["indoors"],
    tags: ["intellectual", "theme", "look up"],
    ingredients: [],
    optionalIngredients: [],
    withWhom: ["friends", "myself"],
    link: [],
    id: "217",
  },
  "218": {
    name: "Zeno’s paradox",
    verb: ["contemplate"],
    moods: ["philosophical"],
    location: ["indoors"],
    tags: ["theme", "look up"],
    ingredients: [],
    optionalIngredients: [],
    withWhom: ["friends", "myself"],
    link: [],
    id: "218",
  },
  "219": {
    name: "Russell's paradox",
    verb: ["contemplate"],
    moods: ["philosophical"],
    location: ["indoors"],
    tags: ["theme", "intellectual", "illusion", "look up"],
    ingredients: [],
    optionalIngredients: [],
    withWhom: ["friends", "myself"],
    link: [],
    id: "219",
  },
  "220": {
    name: "Mary’s room",
    verb: ["contemplate"],
    moods: ["philosophical"],
    location: ["indoors"],
    tags: ["theme", "intellectual", "look up"],
    ingredients: [],
    optionalIngredients: [],
    withWhom: ["friends", "myself"],
    link: [],
    id: "220",
  },
  "221": {
    name: "The Swampman (and apply to sleeping/losing train of thought)",
    verb: ["contemplate"],
    moods: ["philosophical"],
    location: ["indoors"],
    tags: ["theme", "intellectual", "look up"],
    ingredients: [],
    optionalIngredients: [],
    withWhom: ["friends", "myself"],
    link: [],
    id: "221",
  },
  "222": {
    name: "Omar Khayyam",
    verb: ["read"],
    moods: ["curious", "literary", "passive", "cozy"],
    location: ["indoors"],
    tags: ["theme", "look up"],
    ingredients: [],
    optionalIngredients: [],
    withWhom: ["friends", "myself"],
    link: [],
    id: "222",
  },
  "223": {
    name: "Martial’s Epigrams",
    verb: ["read"],
    moods: ["curious", "literary", "passive", "cozy"],
    location: ["indoors"],
    preparationType: "Get",
    tags: ["theme"],
    ingredients: [],
    optionalIngredients: [],
    withWhom: ["friends", "myself"],
    link: [],
    id: "223",
  },
  "224": {
    name: "Oberiu",
    verb: ["read"],
    moods: ["curious", "literary", "passive", "cozy"],
    location: ["indoors"],
    preparationType: "Get",
    tags: ["theme"],
    ingredients: [],
    optionalIngredients: [],
    withWhom: ["friends", "myself"],
    link: [],
    id: "224",
  },
  "225": {
    name: "Grelling–Nelson paradox",
    verb: ["contemplate"],
    moods: ["philosophical"],
    location: ["indoors"],
    tags: ["theme", "look up"],
    ingredients: [],
    optionalIngredients: [],
    withWhom: ["friends", "myself"],
    link: [],
    id: "225",
  },
  "226": {
    name: "Alchemy",
    verb: ["contemplate"],
    moods: ["philosophical", "creative"],
    location: ["indoors"],
    tags: ["theme"],
    ingredients: [],
    optionalIngredients: [],
    withWhom: ["friends", "myself"],
    link: [],
    id: "226",
  },
  "227": {
    name: "Fruits (like pomegranate)",
    verb: ["eat", "look at"],
    moods: ["creative", "hungry"],
    location: ["indoors"],
    preparationType: "Get",
    tags: ["food", "texture", "colors"],
    ingredients: [],
    optionalIngredients: [],
    withWhom: ["friends", "myself"],
    link: [],
    id: "227",
  },
  "228": {
    name: "Tongue twisters/riddles (Pazardan aldim bir tane, eve geldim bin tane)",
    verb: ["try"],
    moods: ["playful", "social"],
    location: ["indoors"],
    tags: ["sound", "activity", "funny"],
    ingredients: [],
    optionalIngredients: [],
    withWhom: ["friends"],
    link: [],
    id: "228",
  },
  "229": {
    name: "Eternal return",
    verb: ["contemplate"],
    moods: ["philosophical"],
    location: ["indoors"],
    tags: ["theme", "intellectual", "look up"],
    ingredients: [],
    optionalIngredients: [],
    withWhom: ["friends", "myself"],
    link: [],
    id: "229",
  },
  "230": {
    name: "Tree hares",
    verb: ["contemplate"],
    moods: ["creative", "philosophical"],
    location: ["indoors"],
    tags: ["theme", "intellectual", "look up"],
    ingredients: [],
    optionalIngredients: [],
    withWhom: ["friends", "myself"],
    link: [],
    id: "230",
  },
  "231": {
    name: "Enso",
    verb: ["draw", "contemplate"],
    moods: ["calm", "serene", "philosophical", "creative", "good"],
    location: ["indoors"],
    tags: ["theme", "concentration", "activity", "calm"],
    ingredients: [],
    optionalIngredients: [],
    withWhom: ["myself"],
    link: [],
    id: "231",
  },
  "232": {
    name: "Things that are universal to all cultures",
    verb: ["contemplate"],
    moods: ["curious", "philosophical", "social"],
    location: ["indoors"],
    tags: ["intellectual", "theme"],
    ingredients: [],
    optionalIngredients: [],
    withWhom: ["friends", "myself"],
    link: ["https://en.wikipedia.org/wiki/Cultural_universal"],
    id: "232",
  },
  "233": {
    name: "Mise en abyme",
    verb: ["contemplate"],
    moods: ["philosophical", "creative"],
    location: ["indoors"],
    tags: ["theme", "ceremony", "look up"],
    ingredients: [],
    optionalIngredients: [],
    withWhom: ["friends", "myself"],
    link: ["https://en.wikipedia.org/wiki/Mise_en_abyme"],
    note: "(Placed in abyss - evening of self reflection?)",
    id: "233",
  },
  "234": {
    name: "Self similarity",
    verb: ["contemplate"],
    moods: ["philosophical", "inquisitive"],
    location: ["indoors"],
    tags: ["theme", "look up"],
    ingredients: [],
    optionalIngredients: [],
    withWhom: ["friends", "myself"],
    link: [],
    id: "234",
  },
  "235": {
    name: "The burning ship fractal",
    verb: ["look at"],
    moods: ["visual", "creative"],
    location: ["indoors"],
    tags: ["visual", "look", "screens", "digital", "immersive"],
    ingredients: [],
    optionalIngredients: [],
    withWhom: ["friends", "myself"],
    link: ["https://en.wikipedia.org/wiki/Burning_Ship_fractal"],
    id: "235",
  },
  "236": {
    name: "A Mayan calendar",
    verb: ["look at", "contemplate"],
    moods: ["philosophical", "curious", "visual"],
    location: ["indoors"],
    tags: ["theme", "look up"],
    ingredients: [],
    optionalIngredients: [],
    withWhom: ["friends", "myself"],
    link: [],
    id: "236",
  },
  "237": {
    name: "Yoshitaka Amano books",
    verb: ["look at"],
    moods: ["visual", "cozy", "colorful"],
    location: ["indoors"],
    preparationType: "Get",
    tags: ["material", "discovery", "look", "colorful"],
    ingredients: [],
    optionalIngredients: [],
    withWhom: ["friends", "myself"],
    link: [],
    id: "237",
  },
  "238": {
    name: "A Dreamatorium",
    verb: ["build", "make"],
    moods: [
      "active",
      "playful",
      "social",
      "solitary",
      "romantic",
      "artsy",
      "immersive",
    ],
    location: ["indoors"],
    tags: ["immsersive", "environment"],
    ingredients: [],
    optionalIngredients: [],
    withWhom: ["friends", "myself"],
    link: [],
    id: "238",
  },
  "239": {
    name: "Tons of tape to distort perspective in a room",
    verb: ["use"],
    moods: ["artsy", "immersive", "creative", "social", "solitary"],
    location: ["indoors"],
    preparationType: "Get",
    tags: ["immersive", "environment"],
    ingredients: [],
    optionalIngredients: [],
    withWhom: ["friends", "myself"],
    link: [],
    id: "239",
  },
  "241": {
    name: "An evening of self reflection",
    verb: ["imagine", "make"],
    moods: ["pensive", "solitary", "inquisitive"],
    location: ["indoors"],
    tags: ["activity"],
    ingredients: [],
    optionalIngredients: [],
    withWhom: ["friends", "myself"],
    link: [],
    id: "241",
  },
  "242": {
    name: "An equal height party",
    verb: ["conduct"],
    moods: ["playful", "social", "active"],
    location: ["indoors"],
    preparationType: "Prepare materials for",
    tags: ["activity", "unusual", "illusion"],
    ingredients: [],
    optionalIngredients: [],
    withWhom: ["friends"],
    link: [],
    id: "242",
  },
  "243": {
    name: "A space. Over time you cover all walls with white t-shirts then over the span of a month you write whatever you want on them like a huge blank canvas. others in the space can too. then you take them down and give them to people as individual shirts",
    verb: ["transform"],
    moods: ["immersive", "ceremonial", "solitary", "social", "romantic"],
    location: ["indoors"],
    preparationType: "Prepare materials for",
    tags: ["activity", "long time", "environment"],
    ingredients: [],
    optionalIngredients: [],
    withWhom: ["myself"],
    link: [],
    id: "243",
  },
  "244": {
    name: "Your own body",
    verb: ["explore"],
    moods: ["solitary", "inquisitive", "cozy", "passive"],
    location: ["indoors"],
    tags: ["discovery", "sensual"],
    ingredients: [],
    optionalIngredients: [],
    withWhom: ["myself"],
    link: [],
    note: "E.g bones in your hands and feet, shining bright light through",
    id: "244",
  },
  "245": {
    name: "Emotions to evoke",
    verb: ["contemplate"],
    moods: ["philosophical", "creative"],
    location: ["indoors"],
    tags: ["theme"],
    ingredients: [],
    optionalIngredients: [],
    withWhom: ["friends", "myself"],
    link: [],
    id: "245",
  },
  "249": {
    name: "Zentangles",
    verb: ["draw"],
    moods: ["artsy", "calm", "cozy"],
    location: ["indoors"],
    tags: ["activity", "creative", "art", "visual"],
    ingredients: [],
    optionalIngredients: [],
    withWhom: ["friends", "myself"],
    link: ["https://zentangle.com/"],
    id: "249",
  },
  "250": {
    name: "psychedelic videos",
    verb: ["watch"],
    moods: ["colorful", "solitary", "social", "passive"],
    location: ["indoors"],
    tags: [
      "cozy",
      "artsy",
      "passive",
      "colorful",
      "activity",
      "visual",
      "screens",
    ],
    ingredients: [],
    optionalIngredients: [],
    withWhom: ["friends", "myself"],
    link: ["https://www.are.na/toby-fox/psychedelic-videos"],
    id: "250",
  },
  "251": {
    name: "psychedelic websites",
    verb: ["play with"],
    moods: ["colorful", "solitary", "social", "passive"],
    location: ["indoors"],
    tags: [
      "cozy",
      "artsy",
      "passive",
      "colorful",
      "activity",
      "visual",
      "screens",
    ],
    ingredients: [],
    optionalIngredients: [],
    withWhom: ["friends", "myself"],
    link: [],
    id: "251",
  },
  "252": {
    name: "A potion",
    verb: ["make"],
    moods: ["creative", "playful"],
    location: ["indoors"],
    tags: ["activity", "playful", "active", "funny"],
    ingredients: [],
    optionalIngredients: [],
    withWhom: ["friends", "myself"],
    link: [],
    id: "252",
  },
  "253": {
    name: "An acrylic ball",
    verb: ["play with"],
    moods: ["playful", "curious"],
    location: ["indoors", "outdoors"],
    preparationType: "Get",
    tags: ["material", "illusion"],
    ingredients: ["Acrylic ball"],
    optionalIngredients: [],
    withWhom: ["friends"],
    description:
      "Acrylic balls are cool. Try rolling it around between your hands. Roll it across the room. Watch the world through it. Watch as your friend plays with it.",
    link: [],
    id: "253",
  },
  "254": {
    name: "Fabric",
    verb: ["use"],
    moods: ["cozy", "tactile", "passive", "creative"],
    location: ["indoors"],
    tags: ["material", "colors", "texture", "category"],
    ingredients: ["Linen", "Corduroy", "Velvet", "Wool", "Microfiber"],
    optionalIngredients: ["Thumbtack", "Painters tape"],
    withWhom: ["friends", "myself"],
    preparation:
      "Obtain scrap pieces of fabric. Better if they are not too small and vary in sizes. If you don't have pieces of fabric, these could be blankets or towels as well.",
    description:
      "Use the pieces of fabric to transform your environment. Drape the fabrics over any screens or technology to go back in time. Cover your walls by hanging the fabric off the walls with thumbtacks or tape. The goal is to end up with an alien environment.",
    link: [],
    note: "Maybe this is more a prepare your environment type of task vs trip activity.",
    id: "254",
    type: "Material,Activity",
  },
  "255": {
    name: "Clothing",
    verb: ["change"],
    moods: ["playful", "curious", "active"],
    location: ["indoors", "outdoors"],
    tags: ["material", "texture", "comfort"],
    ingredients: ["Clothes"],
    optionalIngredients: [],
    withWhom: ["friends", "myself"],
    preparation:
      "Pick clothes that are comfortable. Soft or silky textures, loose waistbands, and stretchy fabrics recommended. Create one or two complete outfits. Lay them out in the shape of they go on your body somewhere easily accessible.",
    description:
      "It's time for an outfit change. Go where you laid down your outfits. Lie down on the outfit of your choice. Take off an item of clothing, put on an item of clothing. Feel fresh.",
    link: [],
    id: "255",
  },
  "256": {
    name: "Scents",
    verb: ["smell"],
    moods: ["cozy", "passive", "calm"],
    location: ["indoors"],
    preparationType: "Get",
    tags: ["material", "category", "scent"],
    ingredients: [
      "Incense",
      "Essential oils",
      "Candles",
      "Soaps",
      "Palo santo",
    ],
    optionalIngredients: ["Essential oil diffuser"],
    withWhom: ["friends"],
    preparation:
      "Gather interesting scents and lay them out to use during your experience.",
    description:
      "Fill the room with a scent that matches your mood. Gift your friend a scent to lift their mood. Pick a scent together to identify with your next activity. Pick a scent to remember your day by.",
    link: [],
    id: "256",
  },
  "257": {
    name: "Wire",
    verb: ["use"],
    moods: ["creative"],
    location: ["indoors", "outdoors"],
    preparationType: "Get",
    tags: ["material", "art", "tool"],
    ingredients: ["Wire"],
    optionalIngredients: [],
    withWhom: ["friends"],
    description:
      "Pick a shape. It could be abstract. It could be something that reminds you of a distinct memory. Could be something that makes you think of your friend. Build that shape by bending the wire and making a sculpture.",
    link: [],
    id: "257",
    type: "Material,Activity",
  },
  "258": {
    name: "Beautiful books",
    verb: ["look at"],
    moods: ["curious", "visual", "cozy"],
    location: ["indoors"],
    tags: ["material", "visual", "discovery", "category"],
    ingredients: ["Books"],
    optionalIngredients: [],
    withWhom: ["friends"],
    preparation: "Stack a list of beautiful, immersive books.",
    description:
      "Look at the art in the books together. Try to notice as many details as you can on each page. Share the details with each other talk about what you like and don't like about the art.",
    link: [],
    id: "258",
  },
  "259": {
    name: "Rope",
    verb: ["use"],
    moods: ["creative", "active"],
    location: ["indoors", "outdoors"],
    preparationType: "Get",
    tags: ["material", "build", "hang", "tool"],
    ingredients: [],
    optionalIngredients: [],
    withWhom: ["friends"],
    description:
      "Create a spiral labyrinth on the floor. Tie yourself to each other from the waist. Play tug of war (careful not to hurt yourself!)\n",
    link: [],
    id: "259",
    type: "Material",
  },
  "260": {
    name: "A movie (not as the sole focus)",
    verb: ["look at"],
    moods: ["visual", "tired", "immersive"],
    location: ["indoors"],
    tags: ["passive", "visual", "activity", "decoration", "screens"],
    ingredients: [],
    optionalIngredients: ["Projector"],
    withWhom: ["friends", "myself"],
    preparation: "Pick a colorful movie.",
    description:
      "Project the movie on the wall on silent while you continue with the rest of your experience.",
    link: [],
    id: "260",
  },
  "261": {
    name: "A white crayon",
    verb: ["play with"],
    moods: ["creative", "playful", "private"],
    location: ["indoors"],
    preparationType: "Get",
    tags: ["material", "art", "visual", "activity"],
    ingredients: ["A white crayon", "Ink"],
    optionalIngredients: [],
    withWhom: ["friends"],
    description:
      "Write a confession to a friend using the white crayon. Ask your friend to paint over it with ink to reveal your message when the time comes.",
    "purchase link": "https://amzn.to/3xhNboW",
    link: [],
    id: "261",
  },
  "262": {
    name: "Rain works",
    verb: ["play with"],
    moods: ["creative", "playful"],
    location: ["outdoors"],
    preparationType: "Get",
    tags: ["discovery", "illusion", "art", "activity"],
    ingredients: ["Rain works"],
    optionalIngredients: [],
    withWhom: ["myself"],
    description:
      "Pick a spot on the sidewalk you pass by regularly. Tune into your current feeling. Do you want to remember this feeling? Or do you want to banish it? Draw something there to remind you when it next rains.",
    "purchase link": "https://amzn.to/3cAZyV0",
    link: ["http://imgur.com/gallery/pHTfvmW", " https://rain.works/"],
    id: "262",
  },
  "264": {
    name: "Neon dust copy",
    verb: ["play with"],
    moods: ["visual", "colorful", "romantic"],
    location: ["indoors"],
    preparationType: "Get",
    tags: ["colors", "environment", "visual", "messy"],
    ingredients: [],
    optionalIngredients: [],
    withWhom: ["myself"],
    description: "Paint your arm with neon dust.",
    "purchase link": "https://amzn.to/3gF41Za",
    link: [],
    id: "264",
  },
}

export const verb = [
  "play with",
  "look at",
  "touch",
  "use",
  "cozy up in",
  "take off",
  "change",
  "eat",
  "smell",
  "make",
  "fly",
  "lie on",
  "look through",
  "drink",
  "listen to",
  "watch",
  "browse",
  "play in",
  "paint things",
  "create",
  "drape",
  "play on",
  "do",
  "see",
  "get inside",
  "play wih",
  "find",
  "contemplate",
  "adorn",
  "draw",
  "hang",
  "come up with",
  "Catch",
  "remember",
  "turn",
  "build",
  "leave",
  "record",
  "settle",
  "try",
  "play",
  "read",
  "imagine",
  "conduct",
  "transform",
  "explore",
]
export const moods = [
  "playful",
  "curious",
  "cozy",
  "passive",
  "visual",
  "creative",
  "colorful",
  "tactile",
  "warm",
  "active",
  "hungry",
  "calm",
  "artsy",
  "tired",
  "serene",
  "pensive",
  "thirsty",
  "mellow",
  "auditory",
  "immersive",
  "experimental",
  "romantic",
  "sensual",
  "sensory",
  "cooling",
  "watery",
  "focused",
  "private",
  "philosophical",
  "alien",
  "funny",
  "nature-loving",
  "social",
  "good",
  "bad",
  "mysterious",
  "vast",
  "exploratory",
  "technological",
  "inellectual",
  "ceremonial",
  "congratulatory",
  "self improvement focused",
  "experiential",
  "nostalgic",
  "solitary",
  "important",
  "inquisitive",
  "talkative",
  "adventurous",
  "future-looking",
  "literary",
]
export const location = ["indoors", "outdoors"]
export const tags = [
  "material",
  "illusion",
  "colors",
  "light",
  "category",
  "texture",
  "cozy",
  "warm",
  "comfort",
  "food",
  "scent",
  "art",
  "tool",
  "visual",
  "discovery",
  "outside",
  "motion",
  "activity",
  "sky",
  "build",
  "hang",
  "game",
  "alcohol",
  "drink",
  "sound",
  "music",
  "passive",
  "decoration",
  "screens",
  "messy",
  "sensual",
  "romance",
  "water",
  "refreshing",
  "sunny",
  "play",
  "immersive",
  "movement",
  "look",
  "environment",
  "trick",
  "living thing",
  "nature",
  "darkness",
  "concentration",
  "calm",
  "tricks",
  "science",
  "project",
  "funny",
  "physics",
  "night",
  "space",
  "ceremony",
  "idea",
  "reminder",
  "unusual",
  "conversation",
  "intellectual",
  "creative",
  "change",
  "long time",
  "childhood",
  "remembering",
  "memories",
  "fabric",
  "theme",
  "look up",
  "metaphor",
  "belief",
  "digital",
  "colorful",
  "immsersive",
  "artsy",
  "playful",
  "active",
]
export const withWhom = ["myself", "friends", "my partner"]
export const ingredients = [
  "Acrylic ball",
  "Reflective ball",
  "Cube lights",
  "EL wire",
  "Fiber optic lights",
  "Candles",
  "Colorful lights",
  "Mirror cube",
  "Linen",
  "Corduroy",
  "Velvet",
  "Wool",
  "Microfiber",
  "Blankets",
  "Clothes",
  "Food",
  "Fruits",
  "Incense",
  "Essential oils",
  "Soaps",
  "Palo santo",
  "Wire",
  "Essential oil diffuser",
  "Books",
  "Paper",
  "Colorful pencils",
  "Markers",
  "Watercolor",
  "Acrylics",
  "Ink",
  "Sketchpads",
  "Kite",
  "Hammock",
  "Tinted glasses",
  "Marbled paper",
  "Wrapping paper",
  "Marbles",
  "Tokaji",
  "A voice modulator",
  "Playlists",
  "Corn starch",
  "Water",
  "Bucket",
  "Body paint",
  "Kiddie pool",
  "Waterproof paint",
  "Marbling kit",
  "Pure black paint",
  "Fidget spinner",
  "Kinetic sand",
  "Kaleidoscope",
  "Teleidoscope",
  "A white crayon",
  "Rain works",
  "Mirrors",
  "K'nex",
  "Lasers",
  "Ruler",
  "Painters tape",
  "Thermal sheets",
  "Giant balloons",
  "Bubbles",
  "Hula hoop",
  "Ribbons",
  "White sheet",
  "Large cardboard box",
  "Hoodie",
  "Shoes",
  "Scissors",
  "Lights",
  "Plywood",
  "Tablesaw",
  "Drill",
  "Hammer",
  "Measuring tape",
  "Chinese finger trap",
  "A fish tank",
  "Fish",
  "Plastic spoons",
  "Glue",
  "Trampoline",
  "Plants",
  "Small bowls",
  "Large bowl",
  "Lighter",
  "Magnetic balls",
  "A CD case",
  "Smartphone",
  "Exacto knife",
  "Polaroid camera",
  "A screen",
]
export const optionalIngredients = [
  "Colorful lights",
  "Thumbtack",
  "Painters tape",
  "Essential oil diffuser",
  "Lasers",
  "Linen",
  "Corduroy",
  "Microfiber",
  "Velvet",
  "Pets",
  "Skin",
  "Avocado",
  "Dragon fruit",
  "Metal",
  "Ice cubes",
  "Markers",
  "Fountain pens",
  "Highlighters",
  "Ink",
  "Colorful pens",
  "Glue",
  "Scissors",
  "Bluetooth speaker",
  "Projector",
  "McSweeny's",
  "Food coloring",
  "Fiber optic lights",
  "Incense",
  "Candles",
  "Marbled paper",
  "Wrapping paper",
  "Tin foil",
  "Balloon pump",
  "Bubble maker",
  "Paper towel rolls",
  "Toilet paper rolls",
  "Cereal boxes",
  "Kirigami book",
]
